// import dayjs from 'dayjs';
// import { toastConfig } from 'config';
// import { toast } from 'react-toastify';
// import { useSelector } from 'react-redux';
// import { useEffect, useRef, useState } from 'react';
// import { withValueCap } from 'pages/globals/global';
// import { NumericFormat } from 'react-number-format';
// import InputLabel from 'components/InputLabel/index';
// import constantFormValues from '../utils/formInputNames';
// import { useLocation, useNavigate } from 'react-router-dom';
// import editIcon from 'assets/images/table-icons/edit_green.svg';
// import CardAccordion from 'components/CardAccordion/CardAccordion';
// import { useGetQueryV3Mutation } from 'store/features/api/graphSlice';
// import { useSendControlDataMutation } from 'store/features/api/apiSlice';
// import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
// import RestorePageOutlinedIcon from '@mui/icons-material/RestorePageOutlined';
// import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
// import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
// import { Col, DatePicker, Form, Input, Row, Select, message, Button, Spin, Tooltip } from 'antd';
// import { useIdentityBulkMutation, useGetSingleIdentityMutation } from 'store/features/process/processApi';
// import { utcConverter, processArrays, stateUpdater, isGrossRentLessThanAdvanceOnEachItem } from '../utils/helperFunc';
// import { Box, Table, useTheme, TableRow, TableHead, TableBody, TableCell, TableFooter, TableContainer } from '@mui/material';

// const LeaseRecordManagementV9EditBasicInfo = ({ screen, vendorList, statusData, singleLeaseData, dataFullyLoaded, viewData = {} }) => {
// 	const form = Form.useFormInstance();
// 	const LeaseEndDate = dayjs().add(1, 'month');

// 	const handleLeaseDateChange = () => {
// 		const leaseStartDate = form.getFieldValue('leaseStartDate');

// 		if (!leaseStartDate) return;

// 		const leaseTerm = form.getFieldValue('leaseTerm');

// 		if (!leaseTerm) {
// 			form.setFieldValue(['changes', 0, 'inputChangeEffectiveDate'], utcConverter(leaseStartDate));

// 			return;
// 		}

// 		const leaseEndDate = leaseStartDate.add(leaseTerm, 'month').subtract(1, 'day');

// 		form.setFieldValue('leaseEndDate', utcConverter(leaseEndDate));
// 		form.setFieldValue('leaseStartDate', utcConverter(leaseStartDate));
// 		form.setFieldValue(['changes', 0, 'inputChangeEffectiveDate'], utcConverter(leaseStartDate));
// 	};

// 	const currentLeaseTerm = Form.useWatch(constantFormValues?.leaseTerm?.key, form);
// 	const currentPaymentFrequency = Form.useWatch(constantFormValues?.paymentFrequency?.key, form);

// 	useEffect(() => {
// 		const currentPaymentFrequency = form.getFieldValue(constantFormValues?.paymentFrequency?.key);

// 		if (currentPaymentFrequency === 'Quarterly') {
// 			form.setFieldValue('modifiedLeaseTerm', Math.floor(form.getFieldValue('leaseTerm') / 3));
// 		} else {
// 			form.setFieldValue('modifiedLeaseTerm', form.getFieldValue('leaseTerm'));
// 		}
// 	}, [currentLeaseTerm, currentPaymentFrequency]);

// 	const grossRentKey = useRef('');
// 	const isUpdatingRef = useRef(false);
// 	const advanceAmountKey = useRef('');

// 	const grossRentList = Form.useWatch('grossRentList_new', form);
// 	const advanceAmountList = Form.useWatch('advanceAmountList_new', form);

// 	useEffect(() => {
// 		if (!Array.isArray(grossRentList) || !Array.isArray(advanceAmountList) || grossRentList.length === 0 || advanceAmountList.length === 0)
// 			return;

// 		const newGrossRentKey = grossRentList.map((item) => `${item.from}-${item.to}`).join('|');
// 		const newAdvanceAmountKey = advanceAmountList.map((item) => `${item.from}-${item.to}`).join('|');

// 		if (newGrossRentKey === grossRentKey.current && newAdvanceAmountKey === advanceAmountKey.current) return;

// 		if (isUpdatingRef.current) return;

// 		isUpdatingRef.current = true;

// 		try {
// 			grossRentKey.current = newGrossRentKey;
// 			advanceAmountKey.current = newAdvanceAmountKey;
// 			const maxGrossRentTerm = Math.max(...grossRentList.map((item) => item.to ?? 0));
// 			const maxAdvanceAmountTerm = Math.max(...advanceAmountList.map((item) => item.to ?? 0));
// 			const maxTerm = Math.max(maxGrossRentTerm, maxAdvanceAmountTerm);
// 			const currentLeaseTerm = form.getFieldValue('leaseTerm_new');

// 			if (currentLeaseTerm !== maxTerm) {
// 				form.setFieldValue('leaseTerm_new', maxTerm);

// 				const currentChanges = form.getFieldValue('changes');
// 				if (currentChanges?.length > 0) {
// 					form.setFieldValue(['changes', currentChanges.length - 1, 'inputChangeLeaseTerm'], maxTerm);
// 				}
// 			}

// 			const leaseStartDate = form.getFieldValue('leaseStartDate');

// 			console.log('leaseStartDate', leaseStartDate, maxTerm);

// 			if (leaseStartDate && maxTerm) {
// 				const leaseEndDate = leaseStartDate.add(maxTerm, 'month').subtract(1, 'day');
// 				const currentLeaseEndDate = form.getFieldValue('leaseEndDate_new');

// 				if (!currentLeaseEndDate || !leaseEndDate.isSame(currentLeaseEndDate)) {
// 					form.setFieldValue('leaseEndDate_new', leaseEndDate);
// 				}
// 			}
// 		} finally {
// 			setTimeout(() => {
// 				isUpdatingRef.current = false;
// 			}, 0);
// 		}
// 	}, [grossRentList, advanceAmountList]);

// 	const handlePaymentFrequencyChange = (value) => {
// 		if (isUpdatingRef.current) return value;

// 		isUpdatingRef.current = true;

// 		try {
// 			const currentChanges = form.getFieldValue('changes');

// 			form.setFieldValue(['changes', currentChanges.length - 1, 'paymentFrequency'], value);
// 		} finally {
// 			isUpdatingRef.current = false;
// 		}

// 		return value;
// 	};

// 	const handlePaymentFrequencyBlur = () => {
// 		if (screen === 'EDIT' && window.debouncedManageChangeRows) {
// 			window.debouncedManageChangeRows();
// 		}
// 	};

// 	const handlePaymentModalityChange = (value) => {
// 		if (isUpdatingRef.current) return value;
// 		isUpdatingRef.current = true;
// 		try {
// 			const currentChanges = form.getFieldValue('changes');

// 			form.setFieldValue(['changes', currentChanges.length - 1, 'paymentTime'], value);
// 		} finally {
// 			isUpdatingRef.current = false;
// 		}

// 		return value;
// 	};

// 	const handlePaymentModalityBlur = () => {
// 		if (screen === 'EDIT' && window.debouncedManageChangeRows) {
// 			window.debouncedManageChangeRows();
// 		}
// 	};

// 	const callDebounced = () => {
// 		if (screen === 'EDIT' && window.debouncedManageChangeRows) {
// 			window.debouncedManageChangeRows();
// 		}
// 	};

// 	const handleAmountChange = (fieldName) => {
// 		const timeoutId = setTimeout(() => {
// 			handleApply();
// 		}, 10);

// 		return () => {
// 			clearTimeout(timeoutId);
// 		};
// 	};

// 	const handleToChange = (fieldName) => {
// 		setTimeout(handleApply, 10);
// 	};

// 	const validateToValueOnBlur = (index) => {
// 		const currentValues = form.getFieldValue('grossRentList_new');
// 		if (!currentValues) return;

// 		const toValue = parseInt(currentValues[index].to);
// 		const fromValue = parseInt(currentValues[index].from);

// 		if (!isNaN(toValue) && !isNaN(fromValue) && toValue < fromValue) {
// 			message.error("'To' value must be greater than or equal to 'From' value");
// 			form.setFields([
// 				{
// 					name: ['grossRentList_new', index, 'to'],
// 					value: '',
// 					errors: ["'To' value must be greater than 'From' value"],
// 				},
// 			]);
// 		}

// 		setTimeout(handleApply, 10);
// 	};

// 	const isRowValid = (row) => {
// 		if (!row) return false;

// 		const toValue = parseInt(row.to);
// 		const fromValue = parseInt(row.from);

// 		if (isNaN(toValue) || toValue <= 0) return false;
// 		if (isNaN(fromValue) || fromValue <= 0) return false;
// 		if (toValue < fromValue) return false;
// 		if (!row.amount) return false;

// 		return true;
// 	};

// 	const handleAddRow = (index) => {
// 		const leaseType = form.getFieldValue('leaseType');
// 		const currentValues = form.getFieldValue('grossRentList_new');

// 		if (!currentValues || !currentValues.length) {
// 			form.setFieldValue('grossRentList_new', [{ from: 1, to: '', amount: '', remarks: '' }]);
// 			return;
// 		}

// 		const currentRow = currentValues[index];

// 		if (!isRowValid(currentRow)) {
// 			message.error('Please complete all required fields in the current row before adding a new one');
// 			return;
// 		}

// 		const toValue = parseInt(currentRow.to);

// 		if (leaseType === 'Operating Lease' && toValue >= 12) {
// 			message.error('Maximum periods taken');
// 			return;
// 		}
// 		const newFrom = toValue + 1;

// 		const newRow = { from: newFrom, to: '', amount: '', remarks: '' };

// 		const updatedValues = [...currentValues.slice(0, index + 1), newRow, ...currentValues.slice(index + 1)];

// 		for (let i = index + 2; i < updatedValues.length; i++) {
// 			const prevTo = parseInt(updatedValues[i - 1].to);
// 			if (!isNaN(prevTo)) {
// 				updatedValues[i].from = prevTo + 1;
// 			}
// 		}

// 		form.setFieldValue('grossRentList_new', updatedValues);

// 		setTimeout(handleApply, 10);
// 	};

// 	const handleApply = () => {
// 		const currentValues = form.getFieldValue('grossRentList_new');

// 		if (!currentValues || currentValues.length === 0) return;
// 		const transformedData = transformRangeDataToAmountArray(currentValues);

// 		form.setFieldValue('grossRents_new', transformedData);

// 		const currentAdvanceAmountsValues = form.getFieldValue('advanceAmountList_new');

// 		if (!currentAdvanceAmountsValues || currentAdvanceAmountsValues?.length === 0) return;

// 		const transformedDataAdvanceAmounts = transformRangeDataToAmountArray(currentAdvanceAmountsValues);

// 		const { processedAdvanceAmounts } = processArrays(transformedData, transformedDataAdvanceAmounts);

// 		form.setFieldValue('advanceAmounts_new', processedAdvanceAmounts);

// 		const currentChanges = form.getFieldValue('changes');

// 		if (currentChanges && currentChanges.length > 0) {
// 			const updatedChanges = [...currentChanges];

// 			updatedChanges[currentChanges.length - 1] = {
// 				...updatedChanges[currentChanges.length - 1],

// 				inputChangeGrossRents: transformedData,
// 			};

// 			form.setFieldValue('changes', updatedChanges);
// 		}

// 		callDebounced();
// 	};

// 	useEffect(() => {
// 		const currentValues = form.getFieldValue('grossRentList_new');

// 		if (!currentValues || !currentValues.length) {
// 			form.setFieldValue('grossRentList_new', [{ from: 1, to: '', amount: '', remarks: '' }]);
// 		}

// 		handleApply();
// 	}, [form]);

// 	const theme = useTheme();

// 	const { state } = useLocation();
// 	const [formState, setFormState] = useState({
// 		showActiveDeactiveModal: false,
// 		showFormSubmitModal: false,
// 		submitPayload: null,
// 		modalData: {
// 			head: state?.processName ?? '',
// 			label: 'Do you want to proceed?',
// 		},
// 	});
// 	const updateFormState = stateUpdater(setFormState);

// 	const [draftSubmit, { isSuccess: isDraftSubmitSuccess }] = useIdentityBulkMutation();

// 	const [updateApi, { isLoading: isUpdateLoading, error: updateError, isSuccess: isUpdateSuccess, isError: isUpdateError }] =
// 		useGetSingleIdentityMutation();

// 	const handleSubmitClick = () => {
// 		const payloadData = [viewData?._id];
// 		const formattedPayload = {
// 			_id: payloadData,
// 			operation: 'submit-draft-bulk',
// 			processCode: state?.processCode,
// 			suffixCode: '',
// 		};

// 		updateFormState('showFormSubmitModal', true);
// 		updateFormState('modalData.head', 'Confirmation');
// 		updateFormState('modalData.label', 'Do you want to submit this lease record?');

// 		updateFormState('submitPayload', formattedPayload);
// 	};

// 	const handleModalSubmit = async () => {
// 		await updateApi({
// 			operation: 'update-single',
// 			processCode: state?.processCode,
// 			suffixCode: '',
// 			data: formState?.submitPayload,
// 			_id: state._id,
// 			version: +singleLeaseData?.version,
// 		});
// 	};

// 	useEffect(() => {
// 		if (isUpdateSuccess) {
// 			toast.success('Success! Record revised successfully', toastConfig);
// 			navigate(-1);
// 		}
// 		if (isUpdateError) {
// 			if (updateError?.data?.code === '501') {
// 				toast.error(updateError?.data?.message, toastConfig);
// 			} else {
// 				toast.error('Failed! Revision not completed', toastConfig);
// 			}
// 		}
// 	}, [isUpdateSuccess, updateError, isUpdateError]);

// 	const setShowFormSubmitModal = (value) => {
// 		updateFormState('showFormSubmitModal', value);
// 	};

// 	const [getLeaseTableData, { data: leaseControlDataV3 }] = useGetQueryV3Mutation();

// 	const [IdentityBulk, { isSuccess: isCaseSuccess, isError: isCaseError }] = useIdentityBulkMutation();

// 	const [isDraft, setIsDraft] = useState(false);

// 	const navigate = useNavigate();

// 	const { creatorOrganizationId } = useSelector((state) => state.profile.profileData);
// 	const companyCode = creatorOrganizationId;
// 	const [getLeaseData, { isLoading: isLeaseControlDataLoading }] = useSendControlDataMutation();

// 	const handleSubmitAction = async () => {
// 		try {
// 			await form.validateFields();
// 			const formData = form.getFieldsValue();

// 			const isGrossRentAndAdvanceAmountValid = isGrossRentLessThanAdvanceOnEachItem(formData?.grossRents_new, formData?.advanceAmounts_new);

// 			if (!isGrossRentAndAdvanceAmountValid) {
// 				message.error('Inconsistency between Lease Payment and Advance Adjustment');
// 				return;
// 			}

// 			const revisePayload = {
// 				...formData,
// 				leaseStartDate: utcConverter(formData?.leaseStartDate),
// 				leaseTitle: formData?.leaseTitle_new,
// 				lessorName: formData?.lessorName,
// 				leaseTerm: formData?.leaseTerm_new,
// 				modifiedLeaseTerm: formData?.leaseTerm_new,
// 				leaseEndDate: utcConverter(formData?.leaseEndDate_new),
// 				paymentModality: formData?.paymentModality_new,
// 				leaseType: formData?.leaseType_new,
// 				initialDiscountRate: formData?.initialDiscountRate_new,
// 				grossRentList: formData?.grossRentList_new,
// 				paymentFrequency: formData?.paymentFrequency_new,
// 				advanceAmountList: formData?.advanceAmountList_new,
// 				advanceAmount: formData?.advanceAmount_new,
// 				advanceAmounts: formData?.advanceAmounts_new,
// 				upfrontLeasePayment: formData?.upfrontLeasePayment_new,
// 				initialDirectCost: formData?.initialDirectCost_new,
// 				securityDeposit: formData?.securityDeposit_new,
// 				grossRents: formData?.grossRents_new,
// 				cashIncentiveAmount: formData?.cashIncentiveAmount_new,
// 				modifiedDateTime: utcConverter(dayjs()),
// 				paymentModalityLabel: constantFormValues?.paymentModality?.options?.find((item) => item.value === formData?.paymentModality_new)
// 					?.label,
// 				lastModifiedDate: utcConverter(dayjs()),
// 				grossRentListSet: formData?.grossRentListSet,
// 				advanceAmountListSet: formData?.advanceAmountListSet,
// 				advanceDuration: formData?.advanceAmounts_new?.filter((item) => item !== 0).length,
// 				modifyCount: statusData?.modifyCount,
// 				editCount: statusData?.editCount + 1,
// 				isRevised: true,
// 			};

// 			updateFormState('showFormSubmitModal', true);
// 			updateFormState('modalData.head', 'Confirmation');
// 			updateFormState('modalData.label', 'Do you want to edit this lease record?');
// 			updateFormState('submitPayload', revisePayload);
// 		} catch (error) {
// 			console.error('Validation Failed:', error);
// 			toast.error('Please fill all required fields', toastConfig);
// 		}
// 	};
// 	const isLeaseLifeCycleOver = () => {
// 		const currentDate = dayjs();
// 		const leaseEndDate = dayjs(form.getFieldValue('leaseEndDate'));

// 		return currentDate.isAfter(leaseEndDate);
// 	};

// 	const [areAllRecordsRecorded, setAreAllRecordsRecorded] = useState(false);
// 	const [showClosedModal, setShowClosedModal] = useState(false);
// 	const [modalData, setModalData] = useState({
// 		head: state?.processName ?? '',
// 		label: 'Do you want to proceed?',
// 	});
// 	const [activeDeactiveSubmitData, setActiveDeactiveSubmitData] = useState(null);

// 	const handleSingleLeaseDeactivate = (status) => {
// 		if (status === 'Closed') {
// 			setModalData({
// 				head: state?.processName ?? 'Lease Record',
// 				action: status,
// 				label: <p>Do you want to close this lease record?</p>,
// 			});
// 		}
// 		if (status === 'Reopened') {
// 			setModalData({
// 				head: state?.processName ?? 'Lease Record',
// 				action: status,
// 				label: <p>Do you want to re-open this lease record?</p>,
// 			});
// 		}

// 		const singleLeasePayload = [{ _id: state._id }];
// 		setActiveDeactiveSubmitData(singleLeasePayload);
// 		setShowClosedModal(true);
// 	};

// 	const modalSubmitHandler = () => {
// 		if (modalData?.action === 'Closed') {
// 			const payload = {
// 				_id: activeDeactiveSubmitData.map((item) => item._id),
// 				operation: 'activate-bulk',
// 				processCode: state?.processCode,
// 				activationStatus: 'Closed',
// 			};
// 			IdentityBulk(payload);
// 		} else if (modalData?.action === 'Reopened') {
// 			const payload = {
// 				_id: activeDeactiveSubmitData.map((item) => item._id),
// 				operation: 'activate-bulk',
// 				processCode: state?.processCode,
// 				activationStatus: 'Reopened',
// 			};
// 			IdentityBulk(payload);
// 		}
// 		setShowClosedModal(false);
// 	};

// 	useEffect(() => {
// 		if (isCaseSuccess) {
// 			toast.success('Success! Lease status updated successfully', toastConfig);
// 			navigate(-1);
// 		} else if (isCaseError) {
// 			toast.error('Failed! Status update not completed', toastConfig);
// 			setShowClosedModal(false);
// 		}
// 	}, [isCaseSuccess, isCaseError]);

// 	const queryV3Loader = async () => {
// 		if (screen !== 'CREATE') {
// 			const version = String(viewData?.data?.version);

// 			if (version && version !== 'null' && version !== 'undefined' && companyCode) {
// 				await getLeaseTableData({
// 					companyCode,
// 					fieldCodes: ['companyCode', 'identityRecordIdString', 'version'],
// 					fieldValues: [companyCode, state?._id, version],
// 					name: 'leaseSchedulesOnVersion-v9',
// 				});
// 			}
// 		}
// 	};

// 	useEffect(() => {
// 		if (isDraftSubmitSuccess) {
// 			navigate(-1);
// 		}
// 	}, [isDraftSubmitSuccess]);

// 	useEffect(() => {
// 		queryV3Loader();
// 		setIsDraft(viewData?.activationStatus?.toLowerCase() === 'draft');
// 	}, [dataFullyLoaded, viewData]);

// 	useEffect(() => {
// 		if (Array.isArray(leaseControlDataV3?.results)) {
// 			const isAllRecordsRecorded = leaseControlDataV3?.results?.every((item) => item?.processStatus === 'Recorded');

// 			setAreAllRecordsRecorded(isAllRecordsRecorded);
// 		}
// 	}, [JSON.stringify(leaseControlDataV3?.results)]);

// 	const [totalAmount, setTotalAmount] = useState(0);
// 	const [totalAmountNew, setTotalAmountNew] = useState(0);
// 	const [rowTotals, setRowTotals] = useState([]);

// 	const formAdvanceAmount = Form.useWatch(constantFormValues?.advanceAmount?.key, form);

// 	useEffect(() => {
// 		if (formAdvanceAmount !== undefined && formAdvanceAmount !== null) {
// 			if (formAdvanceAmount !== totalAmount) {
// 				setTotalAmount(formAdvanceAmount);
// 			}
// 		}
// 	}, [formAdvanceAmount]);

// 	useEffect(() => {
// 		if (totalAmount > 0) {
// 			const currentFormValue = form.getFieldValue(constantFormValues?.advanceAmount?.key);

// 			if (currentFormValue !== totalAmount) {
// 				form.setFieldValue(constantFormValues?.advanceAmount?.key, totalAmount);
// 			}
// 		}
// 	}, [totalAmount]);
// 	function transformRangeDataToAmountArray(rangeData) {
// 		const result = [];

// 		rangeData.forEach((range) => {
// 			const fromValue = parseInt(range.from);
// 			const toValue = parseInt(range.to);

// 			if (isNaN(fromValue) || isNaN(toValue) || fromValue > toValue) {
// 				console.warn('Invalid range found:', range);
// 				return;
// 			}

// 			const amount = parseFloat(String(range.amount).replace(/,/g, ''));

// 			if (isNaN(amount)) {
// 				console.warn('Invalid amount found:', range);
// 				return;
// 			}

// 			const repetitions = toValue - fromValue + 1;

// 			for (let i = 0; i < repetitions; i++) {
// 				result.push(amount);
// 			}
// 		});

// 		return result;
// 	}

// 	const calculateRowTotals = () => {
// 		try {
// 			const values = form.getFieldValue('advanceAmountList_new');

// 			if (values && Array.isArray(values)) {
// 				const newRowTotals = values.map((item) => {
// 					if (!item) return 0;

// 					const fromValue = parseInt(item.from);
// 					const toValue = parseInt(item.to);

// 					let amount = 0;

// 					if (item.amount) {
// 						const amountStr = String(item.amount).replace(/,/g, '');
// 						amount = parseFloat(amountStr);
// 					}

// 					if (isNaN(fromValue) || isNaN(toValue) || isNaN(amount) || toValue < fromValue) {
// 						return 0;
// 					}

// 					return (toValue - fromValue + 1) * amount;
// 				});

// 				setRowTotals(newRowTotals);
// 			}
// 		} catch (error) {
// 			console.error('Error calculating row totals:', error);
// 		}
// 	};

// 	const calculateTotal = () => {
// 		try {
// 			const values = form.getFieldValue('advanceAmountList_new');

// 			if (values && Array.isArray(values)) {
// 				const currentRowTotals = values.map((item) => {
// 					if (!item) return 0;

// 					const fromValue = parseInt(item.from);
// 					const toValue = parseInt(item.to);

// 					let amount = 0;

// 					if (item.amount !== undefined && item.amount !== null && item.amount !== '') {
// 						const amountStr = String(item.amount).replace(/,/g, '');
// 						amount = parseFloat(amountStr);
// 					}

// 					if (isNaN(fromValue) || isNaN(toValue) || isNaN(amount) || toValue < fromValue) {
// 						return 0;
// 					}

// 					return (toValue - fromValue + 1) * amount;
// 				});

// 				setRowTotals(currentRowTotals);

// 				const sum = currentRowTotals.reduce((total, rowTotal) => total + (rowTotal || 0), 0);

// 				setTotalAmountNew(sum);
// 			}
// 		} catch (error) {
// 			console.error('Error calculating total:', error);
// 		}
// 	};

// 	const handleAmountChangeAdvanceAmount = () => {
// 		setTimeout(() => {
// 			calculateTotal();
// 			handleApplyAdvanceAmount();
// 		}, 10);
// 	};

// 	const handleToChangeAdvanceAmount = () => {
// 		setTimeout(() => {
// 			calculateRowTotals();
// 			handleApplyAdvanceAmount();
// 		}, 10);
// 	};

// 	const validateToValueOnBlurAdvanceAmount = (index) => {
// 		const currentValues = form.getFieldValue('advanceAmountList_new');

// 		if (!currentValues) return;

// 		const toValue = parseInt(currentValues[index].to);
// 		const fromValue = parseInt(currentValues[index].from);

// 		if (!isNaN(toValue) && !isNaN(fromValue) && toValue < fromValue) {
// 			message.error("'To' value must be greater than 'From' value");
// 			form.setFields([
// 				{
// 					name: ['advanceAmountList_new', index, 'to'],
// 					value: '',
// 					errors: ["'To' value must be greater than 'From' value"],
// 				},
// 			]);
// 		}

// 		calculateRowTotals();
// 		handleApplyAdvanceAmount();
// 	};

// 	const isRowValidAdvanceAmount = (row) => {
// 		if (!row) return false;

// 		const toValue = parseInt(row.to);
// 		const fromValue = parseInt(row.from);

// 		if (isNaN(toValue) || toValue <= 0) return false;
// 		if (isNaN(fromValue) || fromValue <= 0) return false;
// 		if (toValue < fromValue) return false;
// 		if (!row.amount) return false;

// 		return true;
// 	};

// 	const handleAddRowAdvanceAmount = (index) => {
// 		const leaseType = form.getFieldValue('leaseType');
// 		const currentValues = form.getFieldValue('advanceAmountList_new');

// 		if (!currentValues || !currentValues.length) {
// 			form.setFieldValue('advanceAmountList_new', [{ from: 1, to: '', amount: '', totalAmount: '' }]);
// 			return;
// 		}

// 		const currentRow = currentValues[index];

// 		if (!isRowValidAdvanceAmount(currentRow)) {
// 			message.error('Please complete all required fields in the current row before adding a new one');
// 			return;
// 		}

// 		const toValue = parseInt(currentRow.to);

// 		if (leaseType === 'Operating Lease' && toValue >= 12) {
// 			message.error('Maximum periods taken');
// 			return;
// 		}

// 		const newFrom = toValue + 1;

// 		const newRow = { from: newFrom, to: '', amount: '', totalAmount: '' };

// 		const updatedValues = [...currentValues.slice(0, index + 1), newRow, ...currentValues.slice(index + 1)];

// 		for (let i = index + 2; i < updatedValues.length; i++) {
// 			const prevTo = parseInt(updatedValues[i - 1].to);
// 			if (!isNaN(prevTo)) {
// 				updatedValues[i].from = prevTo + 1;
// 			}
// 		}

// 		form.setFieldValue('advanceAmountList_new', updatedValues);

// 		setTimeout(handleApplyAdvanceAmount, 10);
// 	};

// 	useEffect(() => {
// 		if (screen === 'VIEW' && dataFullyLoaded) {
// 			const timeoutId = setTimeout(() => {
// 				const currentValues = form.getFieldValue('advanceAmountList_new');

// 				if (currentValues && currentValues.length > 0) {
// 					calculateTotal();
// 				}
// 			}, 700);

// 			return () => clearTimeout(timeoutId);
// 		}
// 	}, [screen, dataFullyLoaded]);

// 	const handleApplyAdvanceAmount = () => {
// 		const currentValues = form.getFieldValue('advanceAmountList_new');
// 		if (!currentValues || currentValues?.length === 0) return;

// 		const transformedData = transformRangeDataToAmountArray(currentValues);
// 		const grossRents = form.getFieldValue('grossRents_new');
// 		const { processedAdvanceAmounts } = processArrays(grossRents, transformedData);

// 		const total = transformedData.reduce((sum, amount) => sum + amount, 0);

// 		setTotalAmountNew(total);

// 		form.setFieldsValue({
// 			advanceAmount_new: total,
// 			advanceAmounts_new: processedAdvanceAmounts,
// 		});

// 		form.validateFields(['advanceAmounts_new', 'advanceAmount_new']);

// 		const currentChanges = form.getFieldValue('changes');

// 		if (currentChanges && currentChanges.length > 0) {
// 			const updatedChanges = [...currentChanges];

// 			updatedChanges[currentChanges.length - 1] = {
// 				...updatedChanges[currentChanges.length - 1],

// 				inputChangeAdvance: total > 0 ? total : 0,
// 				inputChangeAdvanceAmounts: processedAdvanceAmounts,
// 			};

// 			form.setFieldValue('changes', updatedChanges);
// 		}
// 	};

// 	useEffect(() => {
// 		const currentValues = form.getFieldValue('advanceAmountList_new');

// 		if (!currentValues || !currentValues.length) {
// 			form.setFieldValue('advanceAmountList_new', [{ from: 1, to: '', amount: '', totalAmount: '' }]);
// 		}

// 		calculateTotal();
// 		calculateRowTotals();
// 	}, []);

// 	return (
// 		<>
// 			<CardAccordion
// 				sx={{ mb: 2 }}
// 				darkTitle={true}
// 				title="Basic Information"
// 				typographySX={{ fontSize: '16px !important' }}
// 				customHeaderSX={{
// 					p: '10px',
// 					backgroundColor: '#e1f0fb !important',
// 				}}
// 			>
// 				<Row gutter={[16, 0]}>
// 					<Form.Item noStyle name="tabIndex" />
// 					<Form.Item noStyle name="endOfFinancialYear" />
// 					<Form.Item noStyle name={constantFormValues?.version?.key} />
// 					<Form.Item noStyle name={constantFormValues?.leaseTerm?.key} />
// 					<Form.Item noStyle name={constantFormValues?.lessorName?.key} />
// 					<Form.Item noStyle name={constantFormValues?.creationDate?.key} />
// 					<Form.Item noStyle name={constantFormValues?.paymentModality?.key} />
// 					<Form.Item noStyle name={constantFormValues?.lastModifiedDate?.key} />
// 					<Form.Item noStyle name={`${constantFormValues?.lessorName?.key}_new`} />
// 					<Form.Item noStyle name={constantFormValues?.paymentModalitylabel?.key} />

// 					<Col xs={24} md={6}>
// 						<InputLabel label={constantFormValues?.LeaseId?.label} head={true} />
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={constantFormValues?.LeaseId?.key}>
// 							<Input disabled placeholder="To be auto generated" style={{ height: '32px', borderRadius: '4px' }} />
// 						</Form.Item>
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={constantFormValues?.LeaseId?.key}>
// 							<Input disabled placeholder="To be auto generated" style={{ height: '32px', borderRadius: '4px' }} />
// 						</Form.Item>
// 					</Col>

// 					<Col xs={24} md={6}>
// 						<InputLabel label={constantFormValues?.leaseStartDate?.label} head={true} />
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={constantFormValues?.leaseStartDate?.key} rules={constantFormValues?.leaseStartDate?.rules}>
// 							<DatePicker
// 								disabled
// 								format="YYYY-MM-DD"
// 								onChange={handleLeaseDateChange}
// 								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
// 							/>
// 						</Form.Item>
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={constantFormValues?.leaseStartDate?.key} rules={constantFormValues?.leaseStartDate?.rules}>
// 							<DatePicker
// 								disabled
// 								format="YYYY-MM-DD"
// 								onChange={handleLeaseDateChange}
// 								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
// 							/>
// 						</Form.Item>
// 					</Col>

// 					<Col xs={24} md={6}>
// 						<InputLabel label={constantFormValues?.leaseTitle?.label} head={true} />
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={constantFormValues?.leaseTitle?.key} rules={constantFormValues?.leaseTitle?.rules}>
// 							<Input disabled placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
// 						</Form.Item>
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={`${constantFormValues?.leaseTitle?.key}_new`} rules={constantFormValues?.leaseTitle?.rules}>
// 							<Input placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
// 						</Form.Item>
// 					</Col>

// 					<Col xs={24} md={6}>
// 						<InputLabel label={constantFormValues?.lessorID?.label} head={true} />
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={constantFormValues?.lessorID?.key} rules={constantFormValues?.lessorID?.rules}>
// 							<Select
// 								showSearch
// 								disabled={true}
// 								filterOption={true}
// 								optionFilterProp="children"
// 								placeholder="Select from the list"
// 								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
// 								onSelect={(_, selectItem) => form.setFieldValue(constantFormValues?.lessorName?.key, selectItem?.children)}
// 							>
// 								{vendorList?.map(({ label, value }) => (
// 									<Select.Option key={value} value={value}>
// 										{label}
// 									</Select.Option>
// 								))}
// 							</Select>
// 						</Form.Item>
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={constantFormValues?.lessorID?.key} rules={constantFormValues?.lessorID?.rules}>
// 							<Select
// 								showSearch
// 								disabled={true}
// 								filterOption={true}
// 								optionFilterProp="children"
// 								placeholder="Select from the list"
// 								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
// 								onSelect={(_, selectItem) => form.setFieldValue(`${constantFormValues?.lessorName?.key}_new`, selectItem?.children)}
// 							>
// 								{vendorList?.map(({ label, value }) => (
// 									<Select.Option key={value} value={value}>
// 										{label}
// 									</Select.Option>
// 								))}
// 							</Select>
// 						</Form.Item>
// 					</Col>

// 					<Col xs={24} md={6}>
// 						<InputLabel label={constantFormValues?.leaseTerm?.label} head={true} />
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name="modifiedLeaseTerm" rules={constantFormValues?.leaseTerm?.rules} noStyle>
// 							<Input disabled type="number" placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
// 						</Form.Item>
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name="leaseTerm_new" rules={constantFormValues?.leaseTerm?.rules} noStyle>
// 							<Input type="number" disabled placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
// 						</Form.Item>
// 					</Col>

// 					<Col xs={24} md={6}>
// 						<InputLabel label={constantFormValues?.leaseEndDate?.label} head={true} />
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={constantFormValues?.leaseEndDate?.key} rules={constantFormValues?.leaseEndDate?.rules}>
// 							<DatePicker disabled value={LeaseEndDate} style={{ width: '100%', height: '32px', borderRadius: '4px' }} />
// 						</Form.Item>
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={`${constantFormValues?.leaseEndDate?.key}_new`} rules={constantFormValues?.leaseEndDate?.rules}>
// 							<DatePicker disabled value={LeaseEndDate} style={{ width: '100%', height: '32px', borderRadius: '4px' }} />
// 						</Form.Item>
// 					</Col>

// 					<Col xs={24} md={6}>
// 						<InputLabel label={constantFormValues?.leaseType?.label} head={true} />
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={constantFormValues?.leaseType?.key} rules={constantFormValues?.leaseType?.rules}>
// 							<Select
// 								disabled
// 								showSearch
// 								filterOption={true}
// 								optionFilterProp="children"
// 								placeholder="Select from the list"
// 								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
// 								onSelect={(value) => {
// 									if (value === 'Operating Lease') {
// 										form.setFieldValue('grossRentList', [{ from: 1, to: '', amount: '', remarks: '' }]);
// 										form.setFieldValue('advanceAmountList', [
// 											{
// 												from: 1,
// 												to: '',
// 												amount: '',
// 												totalAmount: '',
// 											},
// 										]);
// 									}
// 								}}
// 							>
// 								{constantFormValues?.leaseType?.options?.map(({ key, value, label }) => (
// 									<Select.Option key={key} value={value}>
// 										{label}
// 									</Select.Option>
// 								))}
// 							</Select>
// 						</Form.Item>
// 					</Col>
// 					<Col xs={24} md={9}>
// 						<Form.Item name={`${constantFormValues?.leaseType?.key}`} rules={constantFormValues?.leaseType?.rules}>
// 							<Select
// 								disabled
// 								showSearch
// 								filterOption={true}
// 								optionFilterProp="children"
// 								placeholder="Select from the list"
// 								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
// 								onSelect={(value) => {
// 									if (value === 'Operating Lease') {
// 										form.setFieldValue('grossRentList', [{ from: 1, to: '', amount: '', remarks: '' }]);
// 										form.setFieldValue('advanceAmountList', [
// 											{
// 												from: 1,
// 												to: '',
// 												amount: '',
// 												totalAmount: '',
// 											},
// 										]);
// 									}
// 								}}
// 							>
// 								{constantFormValues?.leaseType?.options?.map(({ key, value, label }) => (
// 									<Select.Option key={key} value={value}>
// 										{label}
// 									</Select.Option>
// 								))}
// 							</Select>
// 						</Form.Item>
// 					</Col>

// 					<Col xs={24}>
// 						<Form.Item
// 							shouldUpdate={(previousValue, currentValue) =>
// 								previousValue?.[constantFormValues?.leaseType?.key] !== currentValue?.[constantFormValues?.leaseType?.key]
// 							}
// 							noStyle
// 						>
// 							{({ getFieldValue }) => {
// 								if (getFieldValue(constantFormValues?.leaseType?.key) === 'Finance Lease') {
// 									return (
// 										<Row gutter={[16, 0]}>
// 											<Col xs={24} md={6}>
// 												<InputLabel label={constantFormValues?.initialDiscountRate?.label} head={true} />
// 											</Col>
// 											<Col xs={24} md={9}>
// 												<Form.Item
// 													name={constantFormValues?.initialDiscountRate?.key}
// 													rules={constantFormValues?.initialDiscountRate?.rules}
// 													getValueFromEvent={(e) => {
// 														const value = e.target.value;
// 														const currentChanges = form.getFieldValue('changes');

// 														form.setFieldValue(['changes', currentChanges.length - 1, 'inputChangeDiscountRate'], value);
// 													}}
// 												>
// 													<Input disabled placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
// 												</Form.Item>
// 											</Col>
// 											<Col xs={24} md={9}>
// 												<Form.Item
// 													rules={constantFormValues?.initialDiscountRate?.rules}
// 													name={`${constantFormValues?.initialDiscountRate?.key}_new`}
// 												>
// 													<Input
// 														placeholder="Write here"
// 														style={{ height: '32px', borderRadius: '4px' }}
// 														onChange={(e) => {
// 															const value = e.target.value;
// 															const currentChanges = form.getFieldValue('changes');

// 															form.setFieldValue(`${constantFormValues?.initialDiscountRate?.key}_new`, value);

// 															form.setFieldValue(
// 																['changes', currentChanges.length - 1, 'inputChangeDiscountRate'],
// 																value
// 															);
// 														}}
// 													/>
// 												</Form.Item>
// 											</Col>
// 										</Row>
// 									);
// 								} else {
// 									return <Form.Item name={constantFormValues?.initialDiscountRate?.key} noStyle />;
// 								}
// 							}}
// 						</Form.Item>
// 					</Col>
// 				</Row>
// 			</CardAccordion>

// 			<Row gutter={[16, 0]}>
// 				<Col xs={24} md={12}>
// 					<CardAccordion
// 						sx={{ mb: 2 }}
// 						darkTitle={false}
// 						title="Lease Payment Schedule"
// 						typographySX={{ fontSize: '16px !important' }}
// 						customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px' }}
// 					>
// 						<Form.Item name="changes" noStyle />

// 						<Form.Item name="identityId" noStyle />
// 						<Form.Item name="grossRentListSet" noStyle />
// 						<Form.Item name="effectiveDateHistory" noStyle />
// 						<Form.Item name="modificationSequence" noStyle />

// 						<>
// 							<Form.List name={'grossRentList'}>
// 								{(fields) => (
// 									<>
// 										<TableContainer
// 											className="gross-rent-table"
// 											sx={{
// 												'& table, & th, & td': {
// 													border: '1px solid #e0e0e0',
// 													borderCollapse: 'collapse',
// 												},
// 												'& th, & td': {
// 													p: '5px',
// 												},
// 												'& td .ant-form-item': {
// 													marginBottom: '0px',
// 												},

// 												'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
// 												'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
// 												'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

// 												'& table': { width: '100%' },
// 											}}
// 										>
// 											<Table aria-label="Gross Rent table">
// 												<TableHead>
// 													<TableRow>
// 														<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
// 														<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
// 														<TableCell sx={{ textAlign: 'center' }}>Amount</TableCell>
// 													</TableRow>
// 												</TableHead>

// 												<TableBody>
// 													{fields.length > 0 ? (
// 														fields.map((field, index) => (
// 															<TableRow key={field.key}>
// 																<TableCell>
// 																	<Form.Item name={[field.name, 'from']}>
// 																		<Input
// 																			disabled={true}
// 																			style={{
// 																				width: '100%',
// 																				padding: '8px',
// 																				textAlign: 'center',
// 																				backgroundColor: '#f5f5f5',
// 																			}}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>

// 																<TableCell>
// 																	<Form.Item
// 																		name={[field.name, 'to']}
// 																		rules={[
// 																			{ required: true, message: "Please enter a 'To' value" },
// 																			({ getFieldValue }) => ({
// 																				validator(_, value) {
// 																					const leaseType = getFieldValue('leaseType');
// 																					const fromValue = getFieldValue([
// 																						'grossRentList',
// 																						field.name,
// 																						'from',
// 																					]);
// 																					if (!value || !fromValue) return Promise.resolve();
// 																					if (parseInt(value) < parseInt(fromValue)) {
// 																						return Promise.reject(
// 																							new Error("'To' must be greater than 'From'")
// 																						);
// 																					}
// 																					if (leaseType === 'Operating Lease' && parseInt(value) > 12) {
// 																						return Promise.reject(new Error('Maximum month is 12'));
// 																					}
// 																					return Promise.resolve();
// 																				},
// 																			}),
// 																		]}
// 																	>
// 																		<Input
// 																			disabled
// 																			type="number"
// 																			placeholder="Enter To value"
// 																			onBlur={() => validateToValueOnBlur(index)}
// 																			onChange={() => handleToChange(`${'grossRentList'}.${field.name}.to`)}
// 																			style={{
// 																				width: '100%',
// 																				padding: '8px',

// 																				textAlign: 'center',
// 																			}}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>

// 																<TableCell>
// 																	<Form.Item
// 																		name={[field.name, 'amount']}
// 																		rules={[{ required: true, message: 'Please enter an amount' }]}
// 																	>
// 																		<NumericFormat
// 																			size="small"
// 																			disabled={true}
// 																			decimalScale={2}
// 																			placeholder="0.00"
// 																			fixedDecimalScale
// 																			thousandSeparator=","
// 																			isAllowed={withValueCap}
// 																			customInput={Input}
// 																			onBlur={() => setTimeout(handleApply, 10)}
// 																			style={{
// 																				height: '32px',
// 																				padding: '18px',
// 																				fontSize: '13px',
// 																				textAlign: 'right',
// 																				borderRadius: '4px',
// 																			}}
// 																			onValueChange={(values) => {
// 																				handleAmountChange(`${'grossRentList'}.${field.name}.amount`);
// 																				const currentValues = [...form.getFieldValue('grossRentList')];

// 																				if (currentValues[index]) {
// 																					currentValues[index].amount = values.value || '';

// 																					form.setFieldValue('grossRentList', currentValues);
// 																				}
// 																			}}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>
// 															</TableRow>
// 														))
// 													) : (
// 														<TableRow>
// 															<TableCell colSpan={5} style={{ textAlign: 'center' }}>
// 																No data. Click plus icon in action column to add new entries.
// 															</TableCell>
// 														</TableRow>
// 													)}
// 												</TableBody>
// 											</Table>
// 										</TableContainer>

// 										<Form.Item name="grossRents" noStyle />
// 									</>
// 								)}
// 							</Form.List>
// 						</>
// 					</CardAccordion>

// 					<Row gutter={[16, 0]}>
// 						<Col xs={24} md={6}>
// 							<InputLabel label={constantFormValues?.paymentFrequency?.label} head={true} />
// 						</Col>

// 						<Col xs={24} md={6}>
// 							<Form.Item
// 								name={constantFormValues?.paymentFrequency?.key}
// 								getValueFromEvent={handlePaymentFrequencyChange}
// 								rules={constantFormValues?.paymentFrequency?.rules}
// 							>
// 								<Select
// 									disabled
// 									showSearch
// 									filterOption={true}
// 									optionFilterProp="children"
// 									placeholder="Select from the list"
// 									onBlur={handlePaymentFrequencyBlur}
// 									style={{ width: '100%', height: '32px', borderRadius: '4px' }}
// 								>
// 									{constantFormValues?.paymentFrequency?.options?.map(({ key, value, label }) => (
// 										<Select.Option key={key} value={value}>
// 											{label}
// 										</Select.Option>
// 									))}
// 								</Select>
// 							</Form.Item>
// 						</Col>

// 						<Col xs={24} md={6}>
// 							<InputLabel label={constantFormValues?.paymentModality?.label} head={true} />
// 						</Col>

// 						<Col xs={24} md={6}>
// 							<Form.Item
// 								name={constantFormValues?.paymentModality?.key}
// 								getValueFromEvent={handlePaymentModalityChange}
// 								rules={constantFormValues?.paymentModality?.rules}
// 							>
// 								<Select
// 									disabled
// 									showSearch
// 									filterOption={true}
// 									optionFilterProp="children"
// 									onBlur={handlePaymentModalityBlur}
// 									placeholder="Select from the list"
// 									style={{ width: '100%', height: '32px', borderRadius: '4px' }}
// 								>
// 									{constantFormValues?.paymentModality?.options?.map(({ key, value, label }) => (
// 										<Select.Option key={key} value={value}>
// 											{label}
// 										</Select.Option>
// 									))}
// 								</Select>
// 							</Form.Item>
// 						</Col>
// 					</Row>
// 				</Col>

// 				<Col xs={24} md={12}>
// 					<CardAccordion
// 						sx={{ mb: 2 }}
// 						darkTitle={false}
// 						title="Lease Payment Schedule"
// 						typographySX={{ fontSize: '16px !important' }}
// 						customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px' }}
// 					>
// 						<Form.Item name="identityId" noStyle />
// 						<Form.Item name="grossRentListSet" noStyle />
// 						<Form.Item name="effectiveDateHistory" noStyle />
// 						<Form.Item name="modificationSequence" noStyle />

// 						<>
// 							<Form.List name={'grossRentList_new'}>
// 								{(fields) => (
// 									<>
// 										<TableContainer
// 											className="gross-rent-table"
// 											sx={{
// 												'& table, & th, & td': {
// 													border: '1px solid #e0e0e0',
// 													borderCollapse: 'collapse',
// 												},
// 												'& th, & td': {
// 													p: '5px',
// 												},
// 												'& td .ant-form-item': {
// 													marginBottom: '0px',
// 												},

// 												'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
// 												'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
// 												'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

// 												'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '10%' },

// 												'& table': { width: '100%' },
// 											}}
// 										>
// 											<Table aria-label="Gross Rent table">
// 												<TableHead>
// 													<TableRow>
// 														<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
// 														<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
// 														<TableCell sx={{ textAlign: 'center' }}>Amount</TableCell>
// 														<TableCell sx={{ textAlign: 'center' }}>Action</TableCell>
// 													</TableRow>
// 												</TableHead>

// 												<TableBody>
// 													{fields.length > 0 ? (
// 														fields.map((field, index) => (
// 															<TableRow key={field.key}>
// 																<TableCell>
// 																	<Form.Item name={[field.name, 'from']}>
// 																		<Input
// 																			disabled={true}
// 																			style={{
// 																				width: '100%',
// 																				padding: '8px',
// 																				textAlign: 'center',
// 																				backgroundColor: '#f5f5f5',
// 																			}}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>

// 																<TableCell>
// 																	<Form.Item
// 																		name={[field.name, 'to']}
// 																		rules={[
// 																			{ required: true, message: "Please enter a 'To' value" },
// 																			({ getFieldValue }) => ({
// 																				validator(_, value) {
// 																					const leaseType = getFieldValue('leaseType');
// 																					const fromValue = getFieldValue([
// 																						'grossRentList',
// 																						field.name,
// 																						'from',
// 																					]);
// 																					if (!value || !fromValue) return Promise.resolve();
// 																					if (parseInt(value) < parseInt(fromValue)) {
// 																						return Promise.reject(
// 																							new Error("'To' must be greater than 'From'")
// 																						);
// 																					}
// 																					if (leaseType === 'Operating Lease' && parseInt(value) > 12) {
// 																						return Promise.reject(new Error('Maximum month is 12'));
// 																					}
// 																					return Promise.resolve();
// 																				},
// 																			}),
// 																		]}
// 																	>
// 																		<Input
// 																			type="number"
// 																			placeholder="Enter To value"
// 																			onBlur={() => validateToValueOnBlur(index)}
// 																			onChange={() => handleToChange(`${'grossRentList'}.${field.name}.to`)}
// 																			style={{
// 																				width: '100%',
// 																				padding: '8px',

// 																				textAlign: 'center',
// 																			}}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>
// 																<TableCell>
// 																	<Form.Item
// 																		name={[field.name, 'amount']}
// 																		rules={[{ required: true, message: 'Please enter an amount' }]}
// 																	>
// 																		<NumericFormat
// 																			size="small"
// 																			decimalScale={2}
// 																			placeholder="0.00"
// 																			fixedDecimalScale
// 																			thousandSeparator=","
// 																			isAllowed={withValueCap}
// 																			customInput={Input}
// 																			disabled={screen === 'VIEW'}
// 																			onBlur={() => setTimeout(handleApply, 10)}
// 																			style={{
// 																				height: '32px',
// 																				padding: '18px',
// 																				fontSize: '13px',
// 																				textAlign: 'right',
// 																				borderRadius: '4px',
// 																			}}
// 																			onValueChange={(values) => {
// 																				handleAmountChange(`${'grossRentList_new'}.${field.name}.amount`);
// 																				const currentValues = [...form.getFieldValue('grossRentList_new')];

// 																				if (currentValues[index]) {
// 																					currentValues[index].amount = values.value || '';

// 																					form.setFieldValue('grossRentList_new', currentValues);
// 																				}
// 																			}}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>

// 																<TableCell align="center">
// 																	<>
// 																		{fields.length === 1 && index === 0 && (
// 																			<Tooltip title="Add Row">
// 																				<PlusCircleOutlined
// 																					style={{
// 																						fontSize: '20px',
// 																						color: '#1890ff',
// 																						cursor: 'pointer',
// 																					}}
// 																					onClick={() => handleAddRow(index)}
// 																				/>
// 																			</Tooltip>
// 																		)}

// 																		{fields.length > 1 && index > 0 && index < fields.length - 1 && (
// 																			<Tooltip title="Delete Row">
// 																				<MinusCircleOutlined
// 																					style={{
// 																						fontSize: '20px',
// 																						color: '#ff4d4f',
// 																						cursor: 'pointer',
// 																					}}
// 																					onClick={() => {
// 																						const currentValues = [
// 																							...form.getFieldValue('grossRentList_new'),
// 																						];

// 																						currentValues.splice(index, 1);

// 																						for (let i = index; i < currentValues.length; i++) {
// 																							if (i > 0) {
// 																								const prevTo = parseInt(currentValues[i - 1].to);
// 																								if (!isNaN(prevTo)) {
// 																									currentValues[i].from = prevTo + 1;
// 																								}
// 																							}
// 																						}

// 																						form.setFieldValue('grossRentList_new', currentValues);

// 																						setTimeout(handleApply, 10);
// 																					}}
// 																				/>
// 																			</Tooltip>
// 																		)}

// 																		{fields.length > 1 && index === fields.length - 1 && (
// 																			<>
// 																				<Tooltip title="Add Row">
// 																					<PlusCircleOutlined
// 																						style={{
// 																							fontSize: '20px',
// 																							color: '#1890ff',
// 																							marginRight: '12px',
// 																							cursor: 'pointer',
// 																						}}
// 																						onClick={() => handleAddRow(index)}
// 																					/>
// 																				</Tooltip>
// 																				<Tooltip title="Delete Row">
// 																					<MinusCircleOutlined
// 																						style={{
// 																							fontSize: '20px',
// 																							color: '#ff4d4f',
// 																							cursor: 'pointer',
// 																						}}
// 																						onClick={() => {
// 																							const currentValues = [
// 																								...form.getFieldValue('grossRentList_new'),
// 																							];

// 																							currentValues.splice(index, 1);

// 																							for (let i = index; i < currentValues.length; i++) {
// 																								if (i > 0) {
// 																									const prevTo = parseInt(currentValues[i - 1].to);
// 																									if (!isNaN(prevTo)) {
// 																										currentValues[i].from = prevTo + 1;
// 																									}
// 																								}
// 																							}

// 																							form.setFieldValue('grossRentList_new', currentValues);

// 																							setTimeout(handleApply, 10);
// 																						}}
// 																					/>
// 																				</Tooltip>
// 																			</>
// 																		)}

// 																		{fields.length > 1 && index === 0 && <span></span>}
// 																	</>
// 																</TableCell>
// 															</TableRow>
// 														))
// 													) : (
// 														<TableRow>
// 															<TableCell colSpan={5} style={{ textAlign: 'center' }}>
// 																No data. Click plus icon in action column to add new entries.
// 															</TableCell>
// 														</TableRow>
// 													)}
// 												</TableBody>
// 											</Table>
// 										</TableContainer>

// 										<Form.Item name="grossRents_new" noStyle />
// 									</>
// 								)}
// 							</Form.List>
// 						</>
// 					</CardAccordion>

// 					<Row gutter={[16, 0]}>
// 						<Col xs={24} md={6}>
// 							<InputLabel label={constantFormValues?.paymentFrequency?.label} head={true} />
// 						</Col>

// 						<Col xs={24} md={6}>
// 							<Form.Item
// 								name={`${constantFormValues?.paymentFrequency?.key}_new`}
// 								getValueFromEvent={handlePaymentFrequencyChange}
// 								rules={constantFormValues?.paymentFrequency?.rules}
// 							>
// 								<Select
// 									showSearch
// 									filterOption={true}
// 									optionFilterProp="children"
// 									placeholder="Select from the list"
// 									onBlur={handlePaymentFrequencyBlur}
// 									style={{ width: '100%', height: '32px', borderRadius: '4px' }}
// 								>
// 									{constantFormValues?.paymentFrequency?.options?.map(({ key, value, label }) => (
// 										<Select.Option key={key} value={value}>
// 											{label}
// 										</Select.Option>
// 									))}
// 								</Select>
// 							</Form.Item>
// 						</Col>

// 						<Col xs={24} md={6}>
// 							<InputLabel label={constantFormValues?.paymentModality?.label} head={true} />
// 						</Col>

// 						<Col xs={24} md={6}>
// 							<Form.Item
// 								name={`${constantFormValues?.paymentModality?.key}_new`}
// 								getValueFromEvent={handlePaymentModalityChange}
// 								rules={constantFormValues?.paymentModality?.rules}
// 							>
// 								<Select
// 									showSearch
// 									filterOption={true}
// 									optionFilterProp="children"
// 									onBlur={handlePaymentModalityBlur}
// 									placeholder="Select from the list"
// 									style={{ width: '100%', height: '32px', borderRadius: '4px' }}
// 								>
// 									{constantFormValues?.paymentModality?.options?.map(({ key, value, label }) => (
// 										<Select.Option key={key} value={value}>
// 											{label}
// 										</Select.Option>
// 									))}
// 								</Select>
// 							</Form.Item>
// 						</Col>
// 					</Row>
// 				</Col>

// 				<Col xs={24} md={12}>
// 					<CardAccordion
// 						sx={{ mb: 2 }}
// 						darkTitle={false}
// 						title="Advance Payment & Adjustment"
// 						typographySX={{ fontSize: '16px !important' }}
// 						customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px' }}
// 					>
// 						<Form.Item name="advanceAmountListSet" noStyle />

// 						<Form.List name={'advanceAmountList'}>
// 							{(fields) => {
// 								return (
// 									<>
// 										<TableContainer
// 											className="gross-rent-table"
// 											sx={{
// 												'& table, & th, & td': {
// 													border: '1px solid #e0e0e0',
// 													borderCollapse: 'collapse',
// 												},
// 												'& th, & td': {
// 													p: '5px',
// 												},
// 												'& td .ant-form-item': {
// 													marginBottom: '0px',
// 												},

// 												'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
// 												'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' } ,
// 												'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

// 												'& table': { width: '100%' } ,
// 											}}
// 										>
// 											<Table aria-label="Gross Rent table">
// 												<TableHead>
// 													<TableRow>
// 														<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
// 														<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
// 														<TableCell sx={{ textAlign: 'center' }}>Monthly Adjustment</TableCell>
// 													</TableRow>
// 												</TableHead>
// 												<TableBody>
// 													{fields.length > 0 ? (
// 														fields.map((field, index) => (
// 															<TableRow key={field.key}>
// 																<TableCell>
// 																	<Form.Item name={[field.name, 'from']}>
// 																		<Input
// 																			disabled={true}
// 																			style={{
// 																				padding: '8px',
// 																				width: '100%',
// 																				backgroundColor: '#f5f5f5',
// 																				textAlign: 'center',
// 																			}}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>

// 																<TableCell>
// 																	<Form.Item
// 																		name={[field.name, 'to']}
// 																		rules={[
// 																			{ required: false, message: "Please enter a 'To' value" },
// 																			({ getFieldValue }) => ({
// 																				validator(_, value) {
// 																					const leaseType = getFieldValue('leaseType');
// 																					const fromValue = getFieldValue([
// 																						'advanceAmountList',
// 																						field.name,
// 																						'from',
// 																					]);
// 																					if (!value || !fromValue) return Promise.resolve();
// 																					if (parseInt(value) < parseInt(fromValue)) {
// 																						return Promise.reject(
// 																							new Error("'To' must be greater than 'From'")
// 																						);
// 																					}
// 																					if (leaseType === 'Operating Lease' && parseInt(value) > 12) {
// 																						return Promise.reject(new Error('Maximum month is 12'));
// 																					}
// 																					return Promise.resolve();
// 																				},
// 																			}),
// 																		]}
// 																	>
// 																		<Input
// 																			disabled
// 																			type="number"
// 																			placeholder="Enter To value"
// 																			style={{
// 																				padding: '8px',
// 																				width: '100%',

// 																				textAlign: 'center',
// 																			}}
// 																			onChange={() =>
// 																				handleToChangeAdvanceAmount(`${'advanceAmountList'}.${field.name}.to`)
// 																			}
// 																			onBlur={() => validateToValueOnBlurAdvanceAmount(index)}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>
// 																<TableCell>
// 																	<Form.Item
// 																		name={[field.name, 'amount']}
// 																		rules={[{ required: false, message: 'Please enter an amount' }]}
// 																	>
// 																		<NumericFormat
// 																			disabled
// 																			size="small"
// 																			decimalScale={2}
// 																			placeholder="0.00"
// 																			fixedDecimalScale
// 																			thousandSeparator=","
// 																			isAllowed={withValueCap}
// 																			style={{
// 																				padding: '18px',
// 																				textAlign: 'right',
// 																				height: '32px',
// 																				borderRadius: '4px',
// 																				fontSize: '13px',
// 																			}}
// 																			customInput={Input}
// 																			onValueChange={(values) => {
// 																				handleAmountChangeAdvanceAmount(
// 																					`${'advanceAmountList'}.${field.name}.amount`
// 																				);
// 																				const currentValues = [...form.getFieldValue('advanceAmountList')];

// 																				if (currentValues[index]) {
// 																					currentValues[index].amount = values.value || '';

// 																					form.setFieldValue('advanceAmountList', currentValues);

// 																					const fromValue = parseInt(currentValues[index].from);
// 																					const toValue = parseInt(currentValues[index].to);

// 																					if (!values.value) {
// 																						const newRowTotals = [...rowTotals];
// 																						newRowTotals[index] = 0;
// 																						setRowTotals(newRowTotals);

// 																						const newTotal = newRowTotals.reduce(
// 																							(total, rowTotal) => total + (rowTotal || 0),
// 																							0
// 																						);
// 																						setTotalAmount(newTotal);
// 																						return;
// 																					}

// 																					const amount = parseFloat(values.value);

// 																					if (
// 																						!isNaN(fromValue) &&
// 																						!isNaN(toValue) &&
// 																						!isNaN(amount) &&
// 																						toValue >= fromValue
// 																					) {
// 																						const newRowTotals = [...rowTotals];
// 																						newRowTotals[index] = (toValue - fromValue + 1) * amount;
// 																						setRowTotals(newRowTotals);

// 																						const newTotal = newRowTotals.reduce(
// 																							(total, rowTotal) => total + (rowTotal || 0),
// 																							0
// 																						);
// 																						setTotalAmountNew(newTotal);
// 																					}
// 																				}
// 																			}}
// 																			onBlur={() => {
// 																				setTimeout(() => {
// 																					calculateRowTotals();
// 																					calculateTotal();
// 																					handleApplyAdvanceAmount();
// 																				}, 10);
// 																			}}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>
// 															</TableRow>
// 														))
// 													) : (
// 														<TableRow>
// 															<TableCell colSpan={5} style={{ textAlign: 'center' }}>
// 																No data. Click the plus icon to add new entries.
// 															</TableCell>
// 														</TableRow>
// 													)}
// 												</TableBody>
// 												<TableFooter>
// 													<TableRow sx={{ height: 24 }}>
// 														<TableCell colSpan={2} align="right" style={{ fontWeight: 'bold' }}>
// 															<InputLabel
// 																label={'Advance Payment'}
// 																head={true}
// 																sx={{
// 																	justifyContent: 'end',
// 																	marginBottom: '0px',
// 																}}
// 															/>
// 														</TableCell>
// 														<TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
// 															<NumericFormat
// 																value={totalAmount || 0}
// 																displayType="input"
// 																decimalScale={2}
// 																fixedDecimalScale
// 																thousandSeparator=","
// 																size="small"
// 																style={{
// 																	padding: '18px',
// 																	textAlign: 'right',
// 																	height: '32px',
// 																	borderRadius: '4px',
// 																	fontSize: '13px',
// 																	fontWeight: 'bold',
// 																	backgroundColor: undefined,
// 																	borderColor: undefined,
// 																}}
// 																customInput={Input}
// 																disabled={true}
// 																readOnly={true}
// 															/>
// 														</TableCell>
// 													</TableRow>
// 												</TableFooter>
// 											</Table>
// 										</TableContainer>

// 										<Form.Item name="advanceAmounts" noStyle />
// 									</>
// 								);
// 							}}
// 						</Form.List>
// 					</CardAccordion>
// 				</Col>

// 				<Col xs={24} md={12}>
// 					<CardAccordion
// 						sx={{ mb: 2 }}
// 						darkTitle={false}
// 						title="Advance Payment & Adjustment"
// 						typographySX={{ fontSize: '16px !important' }}
// 						customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px' }}
// 					>
// 						<Form.Item name="advanceAmountListSet" noStyle />

// 						<Form.List name={'advanceAmountList_new'}>
// 							{(fields) => {
// 								return (
// 									<>
// 										<TableContainer
// 											className="gross-rent-table"
// 											sx={{
// 												'& table, & th, & td': {
// 													border: '1px solid #e0e0e0',
// 													borderCollapse: 'collapse',
// 												},
// 												'& th, & td': {
// 													p: '5px',
// 												},
// 												'& td .ant-form-item': {
// 													marginBottom: '0px',
// 												},

// 												'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' } ,
// 												'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
// 												'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' } ,
// 												'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '10%' },
// 												'& th:nth-of-type(5), & td:nth-of-type(5)': { width: '10%' },
// 												'& table': { width: '100%' } ,
// 											}}
// 										>
// 											<Table aria-label="Gross Rent table">
// 												<TableHead>
// 													<TableRow>
// 														<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
// 														<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
// 														<TableCell sx={{ textAlign: 'center' }}>Monthly Adjustment</TableCell>
// 														{screen !== 'VIEW' && screen !== 'EDIT' && (
// 															<TableCell sx={{ textAlign: 'center' }}>Action</TableCell>
// 														)}
// 													</TableRow>
// 												</TableHead>
// 												<TableBody>
// 													{fields.length > 0 ? (
// 														fields.map((field, index) => (
// 															<TableRow key={field.key}>
// 																<TableCell>
// 																	<Form.Item name={[field.name, 'from']}>
// 																		<Input
// 																			disabled={true}
// 																			style={{
// 																				padding: '8px',
// 																				width: '100%',
// 																				backgroundColor: '#f5f5f5',
// 																				textAlign: 'center',
// 																			}}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>

// 																<TableCell>
// 																	<Form.Item
// 																		name={[field.name, 'to']}
// 																		rules={[
// 																			{ required: false, message: "Please enter a 'To' value" },
// 																			({ getFieldValue }) => ({
// 																				validator(_, value) {
// 																					const leaseType = getFieldValue('leaseType');
// 																					const fromValue = getFieldValue([
// 																						'advanceAmountList_new',
// 																						field.name,
// 																						'from',
// 																					]);
// 																					if (!value || !fromValue) return Promise.resolve();
// 																					if (parseInt(value) < parseInt(fromValue)) {
// 																						return Promise.reject(
// 																							new Error("'To' must be greater than 'From'")
// 																						);
// 																					}
// 																					if (leaseType === 'Operating Lease' && parseInt(value) > 12) {
// 																						return Promise.reject(new Error('Maximum month is 12'));
// 																					}
// 																					return Promise.resolve();
// 																				},
// 																			}),
// 																		]}
// 																	>
// 																		<Input
// 																			type="number"
// 																			disabled={screen === 'VIEW' || screen === 'EDIT'}
// 																			placeholder="Enter To value"
// 																			style={{
// 																				padding: '8px',
// 																				width: '100%',

// 																				textAlign: 'center',
// 																			}}
// 																			onChange={() =>
// 																				handleToChangeAdvanceAmount(
// 																					`${'advanceAmountList_new'}.${field.name}.to`
// 																				)
// 																			}
// 																			onBlur={() => validateToValueOnBlurAdvanceAmount(index)}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>
// 																<TableCell>
// 																	<Form.Item
// 																		name={[field.name, 'amount']}
// 																		rules={[{ required: false, message: 'Please enter an amount' }]}
// 																	>
// 																		<NumericFormat
// 																			size="small"
// 																			decimalScale={2}
// 																			placeholder="0.00"
// 																			fixedDecimalScale
// 																			thousandSeparator=","
// 																			isAllowed={withValueCap}
// 																			style={{
// 																				padding: '18px',
// 																				textAlign: 'right',
// 																				height: '32px',
// 																				borderRadius: '4px',
// 																				fontSize: '13px',
// 																			}}
// 																			customInput={Input}
// 																			disabled={screen === 'VIEW' || screen === 'EDIT'}
// 																			onValueChange={(values) => {
// 																				handleAmountChangeAdvanceAmount(
// 																					`${'advanceAmountList_new'}.${field.name}.amount`
// 																				);
// 																				const currentValues = [
// 																					...form.getFieldValue('advanceAmountList_new'),
// 																				];

// 																				if (currentValues[index]) {
// 																					currentValues[index].amount = values.value || '';

// 																					form.setFieldValue('advanceAmountList_new', currentValues);

// 																					const fromValue = parseInt(currentValues[index].from);
// 																					const toValue = parseInt(currentValues[index].to);

// 																					if (!values.value) {
// 																						const newRowTotals = [...rowTotals];
// 																						newRowTotals[index] = 0;
// 																						setRowTotals(newRowTotals);

// 																						const newTotal = newRowTotals.reduce(
// 																							(total, rowTotal) => total + (rowTotal || 0),
// 																							0
// 																						);
// 																						setTotalAmountNew(newTotal);
// 																						return;
// 																					}

// 																					const amount = parseFloat(values.value);

// 																					if (
// 																						!isNaN(fromValue) &&
// 																						!isNaN(toValue) &&
// 																						!isNaN(amount) &&
// 																						toValue >= fromValue
// 																					) {
// 																						const newRowTotals = [...rowTotals];
// 																						newRowTotals[index] = (toValue - fromValue + 1) * amount;
// 																						setRowTotals(newRowTotals);

// 																						const newTotal = newRowTotals.reduce(
// 																							(total, rowTotal) => total + (rowTotal || 0),
// 																							0
// 																						);
// 																						setTotalAmountNew(newTotal);
// 																					}
// 																				}
// 																			}}
// 																			onBlur={() => {
// 																				setTimeout(() => {
// 																					calculateRowTotals();
// 																					calculateTotal();
// 																					handleApplyAdvanceAmount();
// 																				}, 10);
// 																			}}
// 																		/>
// 																	</Form.Item>
// 																</TableCell>

// 																<TableCell align="center">
// 																	<>
// 																		{fields.length === 1 && index === 0 && (
// 																			<Tooltip title="Add Row">
// 																				<PlusCircleOutlined
// 																					style={{
// 																						fontSize: '20px',
// 																						color: '#1890ff',
// 																						cursor: 'pointer',
// 																					}}
// 																					onClick={() => handleAddRowAdvanceAmount(index)}
// 																				/>
// 																			</Tooltip>
// 																		)}

// 																		{fields.length > 1 && index > 0 && index < fields.length - 1 && (
// 																			<Tooltip title="Delete Row">
// 																				<MinusCircleOutlined
// 																					style={{
// 																						fontSize: '20px',
// 																						color: '#ff4d4f',
// 																						cursor: 'pointer',
// 																					}}
// 																					onClick={() => {
// 																						const currentValues = [
// 																							...form.getFieldValue('advanceAmountList_new'),
// 																						];

// 																						const newRowTotals = [...rowTotals];
// 																						newRowTotals.splice(index, 1);
// 																						setRowTotals(newRowTotals);

// 																						currentValues.splice(index, 1);

// 																						for (let i = index; i < currentValues.length; i++) {
// 																							if (i > 0) {
// 																								const prevTo = parseInt(currentValues[i - 1].to);
// 																								if (!isNaN(prevTo)) {
// 																									currentValues[i].from = prevTo + 1;
// 																								}
// 																							}
// 																						}

// 																						form.setFieldValue('advanceAmountList_new', currentValues);

// 																						const newTotal = newRowTotals.reduce(
// 																							(total, rowTotal) => total + (rowTotal || 0),
// 																							0
// 																						);
// 																						setTotalAmountNew(newTotal);
// 																						handleApplyAdvanceAmount();
// 																					}}
// 																				/>
// 																			</Tooltip>
// 																		)}

// 																		{fields.length > 1 && index === fields.length - 1 && (
// 																			<>
// 																				<Tooltip title="Add Row">
// 																					<PlusCircleOutlined
// 																						style={{
// 																							fontSize: '20px',
// 																							color: '#1890ff',
// 																							marginRight: '12px',
// 																							cursor: 'pointer',
// 																						}}
// 																						onClick={() => handleAddRowAdvanceAmount(index)}
// 																					/>
// 																				</Tooltip>
// 																				<Tooltip title="Delete Row">
// 																					<MinusCircleOutlined
// 																						style={{
// 																							fontSize: '20px',
// 																							color: '#ff4d4f',
// 																							cursor: 'pointer',
// 																						}}
// 																						onClick={() => {
// 																							const currentValues = [
// 																								...form.getFieldValue('advanceAmountList_new'),
// 																							];

// 																							const newRowTotals = [...rowTotals];
// 																							newRowTotals.splice(index, 1);
// 																							setRowTotals(newRowTotals);

// 																							currentValues.splice(index, 1);

// 																							for (let i = index; i < currentValues.length; i++) {
// 																								if (i > 0) {
// 																									const prevTo = parseInt(currentValues[i - 1].to);
// 																									if (!isNaN(prevTo)) {
// 																										currentValues[i].from = prevTo + 1;
// 																									}
// 																								}
// 																							}

// 																							form.setFieldValue(
// 																								'advanceAmountList_new',
// 																								currentValues
// 																							);

// 																							const newTotal = newRowTotals.reduce(
// 																								(total, rowTotal) => total + (rowTotal || 0),
// 																								0
// 																							);
// 																							setTotalAmountNew(newTotal);
// 																							handleApplyAdvanceAmount();
// 																						}}
// 																					/>
// 																				</Tooltip>
// 																			</>
// 																		)}

// 																		{fields.length > 1 && index === 0 && <span></span>}
// 																	</>
// 																</TableCell>
// 															</TableRow>
// 														))
// 													) : (
// 														<TableRow>
// 															<TableCell colSpan={5} style={{ textAlign: 'center' }}>
// 																No data. Click the plus icon to add new entries.
// 															</TableCell>
// 														</TableRow>
// 													)}
// 												</TableBody>
// 												<TableFooter>
// 													<TableRow sx={{ height: 24 }}>
// 														<TableCell colSpan={2} align="right" style={{ fontWeight: 'bold' }}>
// 															<InputLabel
// 																label={'Advance Payment'}
// 																head={true}
// 																sx={{
// 																	justifyContent: 'end',
// 																	marginBottom: '0px',
// 																}}
// 															/>
// 														</TableCell>
// 														<TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
// 															<NumericFormat
// 																value={totalAmountNew || 0}
// 																displayType="input"
// 																decimalScale={2}
// 																fixedDecimalScale
// 																thousandSeparator=","
// 																size="small"
// 																style={{
// 																	padding: '18px',
// 																	textAlign: 'right',
// 																	height: '32px',
// 																	borderRadius: '4px',
// 																	fontSize: '13px',
// 																	fontWeight: 'bold',
// 																	backgroundColor: undefined,
// 																	borderColor: undefined,
// 																}}
// 																customInput={Input}
// 																disabled={true}
// 																readOnly={true}
// 															/>
// 														</TableCell>

// 														<TableCell colSpan={1}></TableCell>
// 													</TableRow>
// 												</TableFooter>
// 											</Table>
// 										</TableContainer>

// 										<Form.Item name="advanceAmounts_new" noStyle />
// 									</>
// 								);
// 							}}
// 						</Form.List>
// 					</CardAccordion>
// 				</Col>

// 				<Col xs={24}>
// 					<CardAccordion
// 						darkTitle={false}
// 						title="Other Payments & Incentive"
// 						typographySX={{ fontSize: '16px !important' }}
// 						customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px' }}
// 					>
// 						<Row gutter={[16, 0]}>
// 							<Col xs={24} md={6}>
// 								<InputLabel label={constantFormValues?.upfrontLeasePayment?.label} head={true} />
// 							</Col>
// 							<Col xs={24} md={9}>
// 								<Form.Item name={constantFormValues?.upfrontLeasePayment?.key} rules={constantFormValues?.upfrontLeasePayment?.rules}>
// 									<NumericFormat
// 										disabled
// 										size="large"
// 										decimalScale={2}
// 										placeholder="0.00"
// 										fixedDecimalScale
// 										customInput={Input}
// 										thousandSeparator=","
// 										isAllowed={withValueCap}
// 										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
// 									/>
// 								</Form.Item>
// 							</Col>
// 							<Col xs={24} md={9}>
// 								<Form.Item
// 									name={`${constantFormValues?.upfrontLeasePayment?.key}_new`}
// 									rules={constantFormValues?.upfrontLeasePayment?.rules}
// 								>
// 									<NumericFormat
// 										size="large"
// 										decimalScale={2}
// 										placeholder="0.00"
// 										fixedDecimalScale
// 										customInput={Input}
// 										thousandSeparator=","
// 										isAllowed={withValueCap}
// 										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
// 									/>
// 								</Form.Item>
// 							</Col>

// 							<Col xs={24} md={6}>
// 								<InputLabel label={constantFormValues?.initialDirectCost?.label} head={true} />
// 							</Col>
// 							<Col xs={24} md={9}>
// 								<Form.Item name={constantFormValues?.initialDirectCost?.key} rules={constantFormValues?.initialDirectCost?.rules}>
// 									<NumericFormat
// 										disabled
// 										size="large"
// 										decimalScale={2}
// 										placeholder="0.00"
// 										fixedDecimalScale
// 										customInput={Input}
// 										thousandSeparator=","
// 										isAllowed={withValueCap}
// 										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
// 									/>
// 								</Form.Item>
// 							</Col>
// 							<Col xs={24} md={9}>
// 								<Form.Item
// 									rules={constantFormValues?.initialDirectCost?.rules}
// 									name={`${constantFormValues?.initialDirectCost?.key}_new`}
// 								>
// 									<NumericFormat
// 										size="large"
// 										decimalScale={2}
// 										placeholder="0.00"
// 										fixedDecimalScale
// 										customInput={Input}
// 										thousandSeparator=","
// 										isAllowed={withValueCap}
// 										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
// 									/>
// 								</Form.Item>
// 							</Col>

// 							<Col xs={24} md={6}>
// 								<InputLabel label={constantFormValues?.securityDeposit?.label} head={true} />
// 							</Col>
// 							<Col xs={24} md={9}>
// 								<Form.Item name={constantFormValues?.securityDeposit?.key} rules={constantFormValues?.securityDeposit?.rules}>
// 									<NumericFormat
// 										disabled
// 										size="large"
// 										decimalScale={2}
// 										placeholder="0.00"
// 										fixedDecimalScale
// 										customInput={Input}
// 										thousandSeparator=","
// 										isAllowed={withValueCap}
// 										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
// 									/>
// 								</Form.Item>
// 							</Col>
// 							<Col xs={24} md={9}>
// 								<Form.Item
// 									rules={constantFormValues?.securityDeposit?.rules}
// 									name={`${constantFormValues?.securityDeposit?.key}_new`}
// 								>
// 									<NumericFormat
// 										size="large"
// 										decimalScale={2}
// 										placeholder="0.00"
// 										fixedDecimalScale
// 										customInput={Input}
// 										thousandSeparator=","
// 										isAllowed={withValueCap}
// 										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
// 									/>
// 								</Form.Item>
// 							</Col>

// 							<Col xs={24} md={6}>
// 								<InputLabel label={constantFormValues?.cashIncentiveAmount?.label} head={true} />
// 							</Col>
// 							<Col xs={24} md={9}>
// 								<Form.Item name={constantFormValues?.cashIncentiveAmount?.key} rules={constantFormValues?.securityDeposit?.rules}>
// 									<NumericFormat
// 										disabled
// 										size="large"
// 										decimalScale={2}
// 										fixedDecimalScale
// 										placeholder="0.00"
// 										customInput={Input}
// 										thousandSeparator=","
// 										isAllowed={withValueCap}
// 										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
// 									/>
// 								</Form.Item>
// 							</Col>
// 							<Col xs={24} md={9}>
// 								<Form.Item
// 									rules={constantFormValues?.securityDeposit?.rules}
// 									name={`${constantFormValues?.cashIncentiveAmount?.key}_new`}
// 								>
// 									<NumericFormat
// 										size="large"
// 										decimalScale={2}
// 										fixedDecimalScale
// 										placeholder="0.00"
// 										customInput={Input}
// 										thousandSeparator=","
// 										isAllowed={withValueCap}
// 										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
// 									/>
// 								</Form.Item>
// 							</Col>
// 						</Row>
// 					</CardAccordion>
// 				</Col>

// 				<Form.Item name="grossRents" noStyle />
// 				<Form.Item name="grossRents_new" noStyle />
// 				<Form.Item name="advanceAmounts" noStyle />
// 				<Form.Item name="advanceAmounts_new" noStyle />
// 				<Form.Item name={constantFormValues?.advanceAmount?.key} noStyle />
// 				<Form.Item name={`${constantFormValues?.advanceAmount?.key}_new`} noStyle />
// 				<Form.Item noStyle name={constantFormValues?.inputChangeMonth?.key} />
// 			</Row>

// 			<Box
// 				sx={{
// 					gap: '4px',
// 					pt: '15px',
// 					display: 'flex',
// 					flexDirection: 'column',
// 					justifyContent: 'space-between',
// 				}}
// 			>
// 				<Spin spinning={isLeaseControlDataLoading || isUpdateLoading}>
// 					<Box
// 						sx={{
// 							gap: '4px',
// 							pt: '15px',
// 							display: 'flex',
// 							flexDirection: 'row',
// 							justifyContent: 'space-between',
// 						}}
// 					>
// 						{screen !== 'VIEW' ? (
// 							<Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
// 								<Button
// 									type="primary"
// 									onClick={handleSubmitAction}
// 									style={{
// 										marginTop: 10,
// 										marginBottom: 10,
// 										backgroundColor: theme.palette.lynTheme.main,
// 									}}
// 								>
// 									{screen === 'CREATE' ? 'Submit' : 'Update'}
// 								</Button>
// 							</Box>
// 						) : (
// 							<Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
// 								{viewData && (
// 									<>
// 										{!isDraft ? (
// 											<Button
// 												style={{
// 													margin: '1px',
// 													display: 'flex',
// 													fontSize: '13px',
// 													marginLeft: '6px',
// 													fontWeight: '500',
// 													borderRadius: '6px',
// 													alignItems: 'center',
// 												}}
// 												icon={<img src={editIcon} width={16} height={16} alt="edit" />}
// 												onClick={(e) => {
// 													e.stopPropagation();
// 													if (navigate && state) {
// 														navigate('/static/lease-record-management-v9/edit', {
// 															state: state,
// 														});
// 													}
// 												}}
// 											>
// 												Modify
// 											</Button>
// 										) : (
// 											<Button
// 												type="primary"
// 												onClick={handleSubmitClick}
// 												style={{
// 													backgroundColor: theme.palette.lynTheme.main,
// 												}}
// 											>
// 												Submit
// 											</Button>
// 										)}

// 										<Button
// 											style={{
// 												display: 'flex',
// 												marginLeft: '6px',
// 												alignItems: 'center',
// 											}}
// 											icon={<img src={editIcon} width={16} height={16} alt="edit" />}
// 											onClick={(e) => {
// 												e.stopPropagation();
// 												if (navigate && state) {
// 													navigate('/static/lease-record-management-v9/revise', {
// 														state: state,
// 													});
// 												}
// 											}}
// 										>
// 											Edit
// 										</Button>

// 										{areAllRecordsRecorded &&
// 											isLeaseLifeCycleOver() &&
// 											(viewData?.activationStatus !== 'Closed' ? (
// 												<Button
// 													style={{
// 														margin: '1px',
// 														display: 'flex',
// 														fontSize: '13px',
// 														marginLeft: '6px',
// 														fontWeight: '500',
// 														borderRadius: '6px',
// 														alignItems: 'center',
// 													}}
// 													icon={<AssignmentTurnedInOutlinedIcon />}
// 													onClick={(e) => {
// 														e.stopPropagation();
// 														handleSingleLeaseDeactivate('Closed');
// 													}}
// 												>
// 													Close
// 												</Button>
// 											) : (
// 												<Button
// 													style={{
// 														margin: '1px',
// 														display: 'flex',
// 														fontSize: '13px',
// 														fontWeight: '500',
// 														marginLeft: '6px',
// 														borderRadius: '6px',
// 														alignItems: 'center',
// 													}}
// 													icon={<RestorePageOutlinedIcon />}
// 													onClick={(e) => {
// 														e.stopPropagation();
// 														handleSingleLeaseDeactivate('Reopened');
// 													}}
// 												>
// 													Reopen
// 												</Button>
// 											))}
// 									</>
// 								)}
// 							</Box>
// 						)}
// 					</Box>
// 				</Spin>

// 				{showClosedModal && (
// 					<ComptrollerConfirmModal
// 						modalData={modalData}
// 						showModal={showClosedModal}
// 						setShowModal={setShowClosedModal}
// 						handleSubmit={modalSubmitHandler}
// 					/>
// 				)}

// 				{formState?.showFormSubmitModal && (
// 					<ComptrollerConfirmModal
// 						modalData={formState?.modalData}
// 						handleSubmit={handleModalSubmit}
// 						setShowModal={setShowFormSubmitModal}
// 						showModal={formState?.showFormSubmitModal}
// 					/>
// 				)}
// 			</Box>
// 		</>
// 	);
// };

// export default LeaseRecordManagementV9EditBasicInfo;

import dayjs from 'dayjs';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import PlusIcon from 'assets/icons/plus';
import RemoveIcon from 'assets/icons/remove';
import { useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { withValueCap } from 'pages/globals/global';
import { NumericFormat } from 'react-number-format';
import InputLabel from 'components/InputLabel/index';
import constantFormValues from '../utils/formInputNames';
import AddIconButton from 'components/button/AddIconButton';
import { useLocation, useNavigate } from 'react-router-dom';
import editIcon from 'assets/images/table-icons/edit_green.svg';
import DeleteIconButton from 'components/button/DeleteIconButton';
import { useGetQueryV3Mutation } from 'store/features/api/graphSlice';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import RestorePageOutlinedIcon from '@mui/icons-material/RestorePageOutlined';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import { Col, DatePicker, Form, Input, Row, Select, message, Button, Spin, Tooltip } from 'antd';
import { useIdentityBulkMutation, useGetSingleIdentityMutation } from 'store/features/process/processApi';
import { utcConverter, processArrays, stateUpdater, isGrossRentLessThanAdvanceOnEachItem } from '../utils/helperFunc';
import {
	Box,
	Table,
	Stack,
	useTheme,
	TableRow,
	Typography,
	TableHead,
	TableBody,
	TableCell,
	TableFooter,
	TableContainer,
	IconButton,
} from '@mui/material';

const LeaseRecordManagementV9EditBasicInfo = ({ screen, vendorList, statusData, singleLeaseData, dataFullyLoaded, viewData = {} }) => {
	const form = Form.useFormInstance();
	const LeaseEndDate = dayjs().add(1, 'month');

	const handleLeaseDateChange = () => {
		const leaseStartDate = form.getFieldValue('leaseStartDate');

		if (!leaseStartDate) return;

		const leaseTerm = form.getFieldValue('leaseTerm');

		if (!leaseTerm) {
			form.setFieldValue(['changes', 0, 'inputChangeEffectiveDate'], utcConverter(leaseStartDate));

			return;
		}

		const leaseEndDate = leaseStartDate.add(leaseTerm, 'month').subtract(1, 'day');

		form.setFieldValue('leaseEndDate', utcConverter(leaseEndDate));
		form.setFieldValue('leaseStartDate', utcConverter(leaseStartDate));
		form.setFieldValue(['changes', 0, 'inputChangeEffectiveDate'], utcConverter(leaseStartDate));
	};

	const currentLeaseTerm = Form.useWatch(constantFormValues?.leaseTerm?.key, form);
	const currentPaymentFrequency = Form.useWatch(constantFormValues?.paymentFrequency?.key, form);

	useEffect(() => {
		const currentPaymentFrequency = form.getFieldValue(constantFormValues?.paymentFrequency?.key);

		if (currentPaymentFrequency === 'Quarterly') {
			form.setFieldValue('modifiedLeaseTerm', Math.floor(form.getFieldValue('leaseTerm') / 3));
		} else {
			form.setFieldValue('modifiedLeaseTerm', form.getFieldValue('leaseTerm'));
		}
	}, [currentLeaseTerm, currentPaymentFrequency]);

	const grossRentKey = useRef('');
	const isUpdatingRef = useRef(false);
	const advanceAmountKey = useRef('');

	const grossRentList = Form.useWatch('grossRentList_new', form);
	const advanceAmountList = Form.useWatch('advanceAmountList_new', form);

	useEffect(() => {
		if (!Array.isArray(grossRentList) || !Array.isArray(advanceAmountList) || grossRentList.length === 0 || advanceAmountList.length === 0)
			return;

		const newGrossRentKey = grossRentList.map((item) => `${item.from}-${item.to}`).join('|');
		const newAdvanceAmountKey = advanceAmountList.map((item) => `${item.from}-${item.to}`).join('|');

		if (newGrossRentKey === grossRentKey.current && newAdvanceAmountKey === advanceAmountKey.current) return;

		if (isUpdatingRef.current) return;

		isUpdatingRef.current = true;

		try {
			grossRentKey.current = newGrossRentKey;
			advanceAmountKey.current = newAdvanceAmountKey;
			const maxGrossRentTerm = Math.max(...grossRentList.map((item) => item.to ?? 0));
			const maxAdvanceAmountTerm = Math.max(...advanceAmountList.map((item) => item.to ?? 0));
			const maxTerm = Math.max(maxGrossRentTerm, maxAdvanceAmountTerm);
			const currentLeaseTerm = form.getFieldValue('leaseTerm_new');

			if (currentLeaseTerm !== maxTerm) {
				form.setFieldValue('leaseTerm_new', maxTerm);

				const currentChanges = form.getFieldValue('changes');
				if (currentChanges?.length > 0) {
					form.setFieldValue(['changes', currentChanges.length - 1, 'inputChangeLeaseTerm'], maxTerm);
				}
			}

			const leaseStartDate = form.getFieldValue('leaseStartDate');

			if (leaseStartDate && maxTerm) {
				const leaseEndDate = leaseStartDate.add(maxTerm, 'month').subtract(1, 'day');
				const currentLeaseEndDate = form.getFieldValue('leaseEndDate_new');

				if (!currentLeaseEndDate || !leaseEndDate.isSame(currentLeaseEndDate)) {
					form.setFieldValue('leaseEndDate_new', leaseEndDate);
				}
			}
		} finally {
			setTimeout(() => {
				isUpdatingRef.current = false;
			}, 0);
		}
	}, [grossRentList, advanceAmountList]);

	const handlePaymentFrequencyChange = (value) => {
		if (isUpdatingRef.current) return value;

		isUpdatingRef.current = true;

		try {
			const currentChanges = form.getFieldValue('changes');

			form.setFieldValue(['changes', currentChanges.length - 1, 'paymentFrequency'], value);
		} finally {
			isUpdatingRef.current = false;
		}

		return value;
	};

	const handlePaymentFrequencyBlur = () => {
		if (screen === 'EDIT' && window.debouncedManageChangeRows) {
			window.debouncedManageChangeRows();
		}
	};

	const handlePaymentModalityChange = (value) => {
		if (isUpdatingRef.current) return value;
		isUpdatingRef.current = true;
		try {
			const currentChanges = form.getFieldValue('changes');

			form.setFieldValue(['changes', currentChanges.length - 1, 'paymentTime'], value);
		} finally {
			isUpdatingRef.current = false;
		}

		return value;
	};

	const handlePaymentModalityBlur = () => {
		if (screen === 'EDIT' && window.debouncedManageChangeRows) {
			window.debouncedManageChangeRows();
		}
	};

	const callDebounced = () => {
		if (screen === 'EDIT' && window.debouncedManageChangeRows) {
			window.debouncedManageChangeRows();
		}
	};

	const handleAmountChange = (fieldName) => {
		const timeoutId = setTimeout(() => {
			handleApply();
		}, 10);

		return () => {
			clearTimeout(timeoutId);
		};
	};

	const handleToChange = (fieldName) => {
		setTimeout(handleApply, 10);
	};

	const validateToValueOnBlur = (index) => {
		const currentValues = form.getFieldValue('grossRentList_new');
		if (!currentValues) return;

		const toValue = parseInt(currentValues[index].to);
		const fromValue = parseInt(currentValues[index].from);

		if (!isNaN(toValue) && !isNaN(fromValue) && toValue < fromValue) {
			message.error("'To' value must be greater than or equal to 'From' value");
			form.setFields([
				{
					name: ['grossRentList_new', index, 'to'],
					value: '',
					errors: ["'To' value must be greater than 'From' value"],
				},
			]);
		}

		setTimeout(handleApply, 10);
	};

	const isRowValid = (row) => {
		if (!row) return false;

		const toValue = parseInt(row.to);
		const fromValue = parseInt(row.from);

		if (isNaN(toValue) || toValue <= 0) return false;
		if (isNaN(fromValue) || fromValue <= 0) return false;
		if (toValue < fromValue) return false;
		if (!row.amount) return false;

		return true;
	};

	const handleAddRow = (index) => {
		const leaseType = form.getFieldValue('leaseType');
		const currentValues = form.getFieldValue('grossRentList_new');

		if (!currentValues || !currentValues.length) {
			form.setFieldValue('grossRentList_new', [{ from: 1, to: '', amount: '', remarks: '' }]);
			return;
		}

		const currentRow = currentValues[index];

		if (!isRowValid(currentRow)) {
			message.error('Please complete all required fields in the current row before adding a new one');
			return;
		}

		const toValue = parseInt(currentRow.to);

		if (leaseType === 'Operating Lease' && toValue >= 12) {
			message.error('Maximum periods taken');
			return;
		}
		const newFrom = toValue + 1;

		const newRow = { from: newFrom, to: '', amount: '', remarks: '' };

		const updatedValues = [...currentValues.slice(0, index + 1), newRow, ...currentValues.slice(index + 1)];

		for (let i = index + 2; i < updatedValues.length; i++) {
			const prevTo = parseInt(updatedValues[i - 1].to);
			if (!isNaN(prevTo)) {
				updatedValues[i].from = prevTo + 1;
			}
		}

		form.setFieldValue('grossRentList_new', updatedValues);

		setTimeout(handleApply, 10);
	};

	const handleApply = () => {
		const currentValues = form.getFieldValue('grossRentList_new');

		if (!currentValues || currentValues.length === 0) return;
		const transformedData = transformRangeDataToAmountArray(currentValues);

		form.setFieldValue('grossRents_new', transformedData);

		const currentAdvanceAmountsValues = form.getFieldValue('advanceAmountList_new');

		if (!currentAdvanceAmountsValues || currentAdvanceAmountsValues?.length === 0) return;

		const transformedDataAdvanceAmounts = transformRangeDataToAmountArray(currentAdvanceAmountsValues);

		const { processedAdvanceAmounts } = processArrays(transformedData, transformedDataAdvanceAmounts);

		form.setFieldValue('advanceAmounts_new', processedAdvanceAmounts);

		const currentChanges = form.getFieldValue('changes');

		if (currentChanges && currentChanges.length > 0) {
			const updatedChanges = [...currentChanges];

			updatedChanges[currentChanges.length - 1] = {
				...updatedChanges[currentChanges.length - 1],

				inputChangeGrossRents: transformedData,
			};

			form.setFieldValue('changes', updatedChanges);
		}

		callDebounced();
	};

	useEffect(() => {
		const currentValues = form.getFieldValue('grossRentList_new');

		if (!currentValues || !currentValues.length) {
			form.setFieldValue('grossRentList_new', [{ from: 1, to: '', amount: '', remarks: '' }]);
		}

		handleApply();
	}, [form]);

	const theme = useTheme();

	const { state } = useLocation();
	const [formState, setFormState] = useState({
		showActiveDeactiveModal: false,
		showFormSubmitModal: false,
		submitPayload: null,
		modalData: {
			head: state?.processName ?? '',
			label: 'Do you want to proceed?',
		},
	});
	const updateFormState = stateUpdater(setFormState);

	const [draftSubmit, { isSuccess: isDraftSubmitSuccess }] = useIdentityBulkMutation();

	const [updateApi, { isLoading: isUpdateLoading, error: updateError, isSuccess: isUpdateSuccess, isError: isUpdateError }] =
		useGetSingleIdentityMutation();

	const handleSubmitClick = () => {
		const payloadData = [viewData?._id];
		const formattedPayload = {
			_id: payloadData,
			operation: 'submit-draft-bulk',
			processCode: state?.processCode,
			suffixCode: '',
		};

		updateFormState('showFormSubmitModal', true);
		updateFormState('modalData.head', 'Confirmation');
		updateFormState('modalData.label', 'Do you want to submit this lease record?');

		updateFormState('submitPayload', formattedPayload);
	};

	const handleModalSubmit = async () => {
		await updateApi({
			operation: 'update-single',
			processCode: state?.processCode,
			suffixCode: '',
			data: formState?.submitPayload,
			_id: state._id,
			version: +singleLeaseData?.version,
		});
	};

	useEffect(() => {
		if (isUpdateSuccess) {
			toast.success('Success! Record revised successfully', toastConfig);
			navigate(-1);
		}
		if (isUpdateError) {
			if (updateError?.data?.code === '501') {
				toast.error(updateError?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Revision not completed', toastConfig);
			}
		}
	}, [isUpdateSuccess, updateError, isUpdateError]);

	const setShowFormSubmitModal = (value) => {
		updateFormState('showFormSubmitModal', value);
	};

	const [getLeaseTableData, { data: leaseControlDataV3 }] = useGetQueryV3Mutation();

	const [IdentityBulk, { isSuccess: isCaseSuccess, isError: isCaseError }] = useIdentityBulkMutation();

	const [isDraft, setIsDraft] = useState(false);

	const navigate = useNavigate();

	const { creatorOrganizationId } = useSelector((state) => state.profile.profileData);
	const companyCode = creatorOrganizationId;
	const [getLeaseData, { isLoading: isLeaseControlDataLoading }] = useSendControlDataMutation();

	const handleSubmitAction = async () => {
		try {
			await form.validateFields();
			const formData = form.getFieldsValue();

			const isGrossRentAndAdvanceAmountValid = isGrossRentLessThanAdvanceOnEachItem(formData?.grossRents_new, formData?.advanceAmounts_new);

			if (!isGrossRentAndAdvanceAmountValid) {
				message.error('Inconsistency between Lease Payment and Advance Adjustment');
				return;
			}

			const revisePayload = {
				...formData,
				leaseStartDate: utcConverter(formData?.leaseStartDate),
				leaseTitle: formData?.leaseTitle_new,
				lessorName: formData?.lessorName,
				leaseTerm: formData?.leaseTerm_new,
				modifiedLeaseTerm: formData?.leaseTerm_new,
				leaseEndDate: utcConverter(formData?.leaseEndDate_new),
				paymentModality: formData?.paymentModality_new,
				leaseType: formData?.leaseType_new,
				initialDiscountRate: formData?.initialDiscountRate_new,
				grossRentList: formData?.grossRentList_new,
				paymentFrequency: formData?.paymentFrequency_new,
				advanceAmountList: formData?.advanceAmountList_new,
				advanceAmount: formData?.advanceAmount_new,
				advanceAmounts: formData?.advanceAmounts_new,
				upfrontLeasePayment: formData?.upfrontLeasePayment_new,
				initialDirectCost: formData?.initialDirectCost_new,
				securityDeposit: formData?.securityDeposit_new,
				grossRents: formData?.grossRents_new,
				cashIncentiveAmount: formData?.cashIncentiveAmount_new,
				modifiedDateTime: utcConverter(dayjs()),
				paymentModalityLabel: constantFormValues?.paymentModality?.options?.find((item) => item.value === formData?.paymentModality_new)
					?.label,
				lastModifiedDate: utcConverter(dayjs()),
				grossRentListSet: formData?.grossRentListSet,
				advanceAmountListSet: formData?.advanceAmountListSet,
				advanceDuration: formData?.advanceAmounts_new?.filter((item) => item !== 0).length,
				modifyCount: statusData?.modifyCount,
				editCount: statusData?.editCount + 1,
				isRevised: true,
			};

			updateFormState('showFormSubmitModal', true);
			updateFormState('modalData.head', 'Confirmation');
			updateFormState('modalData.label', 'Do you want to edit this lease record?');
			updateFormState('submitPayload', revisePayload);
		} catch (error) {
			console.error('Validation Failed:', error);
			toast.error('Please fill all required fields', toastConfig);
		}
	};
	const isLeaseLifeCycleOver = () => {
		const currentDate = dayjs();
		const leaseEndDate = dayjs(form.getFieldValue('leaseEndDate'));

		return currentDate.isAfter(leaseEndDate);
	};

	const [areAllRecordsRecorded, setAreAllRecordsRecorded] = useState(false);
	const [showClosedModal, setShowClosedModal] = useState(false);
	const [modalData, setModalData] = useState({
		head: state?.processName ?? '',
		label: 'Do you want to proceed?',
	});
	const [activeDeactiveSubmitData, setActiveDeactiveSubmitData] = useState(null);

	const handleSingleLeaseDeactivate = (status) => {
		if (status === 'Closed') {
			setModalData({
				head: state?.processName ?? 'Lease Record',
				action: status,
				label: <p>Do you want to close this lease record?</p>,
			});
		}
		if (status === 'Reopened') {
			setModalData({
				head: state?.processName ?? 'Lease Record',
				action: status,
				label: <p>Do you want to re-open this lease record?</p>,
			});
		}

		const singleLeasePayload = [{ _id: state._id }];
		setActiveDeactiveSubmitData(singleLeasePayload);
		setShowClosedModal(true);
	};

	const modalSubmitHandler = () => {
		if (modalData?.action === 'Closed') {
			const payload = {
				_id: activeDeactiveSubmitData.map((item) => item._id),
				operation: 'activate-bulk',
				processCode: state?.processCode,
				activationStatus: 'Closed',
			};
			IdentityBulk(payload);
		} else if (modalData?.action === 'Reopened') {
			const payload = {
				_id: activeDeactiveSubmitData.map((item) => item._id),
				operation: 'activate-bulk',
				processCode: state?.processCode,
				activationStatus: 'Reopened',
			};
			IdentityBulk(payload);
		}
		setShowClosedModal(false);
	};

	useEffect(() => {
		if (isCaseSuccess) {
			toast.success('Success! Lease status updated successfully', toastConfig);
			navigate(-1);
		} else if (isCaseError) {
			toast.error('Failed! Status update not completed', toastConfig);
			setShowClosedModal(false);
		}
	}, [isCaseSuccess, isCaseError]);

	const queryV3Loader = async () => {
		if (screen !== 'CREATE') {
			const version = String(viewData?.data?.version);

			if (version && version !== 'null' && version !== 'undefined' && companyCode) {
				await getLeaseTableData({
					companyCode,
					fieldCodes: ['companyCode', 'identityRecordIdString', 'version'],
					fieldValues: [companyCode, state?._id, version],
					name: 'leaseSchedulesOnVersion-v9',
				});
			}
		}
	};

	useEffect(() => {
		if (isDraftSubmitSuccess) {
			navigate(-1);
		}
	}, [isDraftSubmitSuccess]);

	useEffect(() => {
		queryV3Loader();
		setIsDraft(viewData?.activationStatus?.toLowerCase() === 'draft');
	}, [dataFullyLoaded, viewData]);

	useEffect(() => {
		if (Array.isArray(leaseControlDataV3?.results)) {
			const isAllRecordsRecorded = leaseControlDataV3?.results?.every((item) => item?.processStatus === 'Recorded');

			setAreAllRecordsRecorded(isAllRecordsRecorded);
		}
	}, [JSON.stringify(leaseControlDataV3?.results)]);

	const [totalAmount, setTotalAmount] = useState(0);
	const [totalAmountNew, setTotalAmountNew] = useState(0);
	const [rowTotals, setRowTotals] = useState([]);

	const formAdvanceAmount = Form.useWatch(constantFormValues?.advanceAmount?.key, form);

	useEffect(() => {
		if (formAdvanceAmount !== undefined && formAdvanceAmount !== null) {
			if (formAdvanceAmount !== totalAmount) {
				setTotalAmount(formAdvanceAmount);
			}
		}
	}, [formAdvanceAmount]);

	useEffect(() => {
		if (totalAmount > 0) {
			const currentFormValue = form.getFieldValue(constantFormValues?.advanceAmount?.key);

			if (currentFormValue !== totalAmount) {
				form.setFieldValue(constantFormValues?.advanceAmount?.key, totalAmount);
			}
		}
	}, [totalAmount]);
	function transformRangeDataToAmountArray(rangeData) {
		const result = [];

		rangeData.forEach((range) => {
			const fromValue = parseInt(range.from);
			const toValue = parseInt(range.to);

			if (isNaN(fromValue) || isNaN(toValue) || fromValue > toValue) {
				console.warn('Invalid range found:', range);
				return;
			}

			const amount = parseFloat(String(range.amount).replace(/,/g, ''));

			if (isNaN(amount)) {
				console.warn('Invalid amount found:', range);
				return;
			}

			const repetitions = toValue - fromValue + 1;

			for (let i = 0; i < repetitions; i++) {
				result.push(amount);
			}
		});

		return result;
	}

	const calculateRowTotals = () => {
		try {
			const values = form.getFieldValue('advanceAmountList_new');

			if (values && Array.isArray(values)) {
				const newRowTotals = values.map((item) => {
					if (!item) return 0;

					const fromValue = parseInt(item.from);
					const toValue = parseInt(item.to);

					let amount = 0;

					if (item.amount) {
						const amountStr = String(item.amount).replace(/,/g, '');
						amount = parseFloat(amountStr);
					}

					if (isNaN(fromValue) || isNaN(toValue) || isNaN(amount) || toValue < fromValue) {
						return 0;
					}

					return (toValue - fromValue + 1) * amount;
				});

				setRowTotals(newRowTotals);
			}
		} catch (error) {
			console.error('Error calculating row totals:', error);
		}
	};

	const calculateTotal = () => {
		try {
			const values = form.getFieldValue('advanceAmountList_new');

			if (values && Array.isArray(values)) {
				const currentRowTotals = values.map((item) => {
					if (!item) return 0;

					const fromValue = parseInt(item.from);
					const toValue = parseInt(item.to);

					let amount = 0;

					if (item.amount !== undefined && item.amount !== null && item.amount !== '') {
						const amountStr = String(item.amount).replace(/,/g, '');
						amount = parseFloat(amountStr);
					}

					if (isNaN(fromValue) || isNaN(toValue) || isNaN(amount) || toValue < fromValue) {
						return 0;
					}

					return (toValue - fromValue + 1) * amount;
				});

				setRowTotals(currentRowTotals);

				const sum = currentRowTotals.reduce((total, rowTotal) => total + (rowTotal || 0), 0);

				setTotalAmountNew(sum);
			}
		} catch (error) {
			console.error('Error calculating total:', error);
		}
	};

	const handleAmountChangeAdvanceAmount = () => {
		setTimeout(() => {
			calculateTotal();
			handleApplyAdvanceAmount();
		}, 10);
	};

	const handleToChangeAdvanceAmount = () => {
		setTimeout(() => {
			calculateRowTotals();
			handleApplyAdvanceAmount();
		}, 10);
	};

	const validateToValueOnBlurAdvanceAmount = (index) => {
		const currentValues = form.getFieldValue('advanceAmountList_new');

		if (!currentValues) return;

		const toValue = parseInt(currentValues[index].to);
		const fromValue = parseInt(currentValues[index].from);

		if (!isNaN(toValue) && !isNaN(fromValue) && toValue < fromValue) {
			message.error("'To' value must be greater than 'From' value");
			form.setFields([
				{
					name: ['advanceAmountList_new', index, 'to'],
					value: '',
					errors: ["'To' value must be greater than 'From' value"],
				},
			]);
		}

		calculateRowTotals();
		handleApplyAdvanceAmount();
	};

	const isRowValidAdvanceAmount = (row) => {
		if (!row) return false;

		const toValue = parseInt(row.to);
		const fromValue = parseInt(row.from);

		if (isNaN(toValue) || toValue <= 0) return false;
		if (isNaN(fromValue) || fromValue <= 0) return false;
		if (toValue < fromValue) return false;
		if (!row.amount) return false;

		return true;
	};

	const handleAddRowAdvanceAmount = (index) => {
		const leaseType = form.getFieldValue('leaseType');
		const currentValues = form.getFieldValue('advanceAmountList_new');

		if (!currentValues || !currentValues.length) {
			form.setFieldValue('advanceAmountList_new', [{ from: 1, to: '', amount: '', totalAmount: '' }]);
			return;
		}

		const currentRow = currentValues[index];

		if (!isRowValidAdvanceAmount(currentRow)) {
			message.error('Please complete all required fields in the current row before adding a new one');
			return;
		}

		const toValue = parseInt(currentRow.to);

		if (leaseType === 'Operating Lease' && toValue >= 12) {
			message.error('Maximum periods taken');
			return;
		}

		const newFrom = toValue + 1;

		const newRow = { from: newFrom, to: '', amount: '', totalAmount: '' };

		const updatedValues = [...currentValues.slice(0, index + 1), newRow, ...currentValues.slice(index + 1)];

		for (let i = index + 2; i < updatedValues.length; i++) {
			const prevTo = parseInt(updatedValues[i - 1].to);
			if (!isNaN(prevTo)) {
				updatedValues[i].from = prevTo + 1;
			}
		}

		form.setFieldValue('advanceAmountList_new', updatedValues);

		setTimeout(handleApplyAdvanceAmount, 10);
	};

	useEffect(() => {
		if (screen === 'VIEW' && dataFullyLoaded) {
			const timeoutId = setTimeout(() => {
				const currentValues = form.getFieldValue('advanceAmountList_new');

				if (currentValues && currentValues.length > 0) {
					calculateTotal();
				}
			}, 700);

			return () => clearTimeout(timeoutId);
		}
	}, [screen, dataFullyLoaded]);

	const handleApplyAdvanceAmount = () => {
		const currentValues = form.getFieldValue('advanceAmountList_new');
		if (!currentValues || currentValues?.length === 0) return;

		const transformedData = transformRangeDataToAmountArray(currentValues);
		const grossRents = form.getFieldValue('grossRents_new');
		const { processedAdvanceAmounts } = processArrays(grossRents, transformedData);

		const total = transformedData.reduce((sum, amount) => sum + amount, 0);

		setTotalAmountNew(total);

		form.setFieldsValue({
			advanceAmount_new: total,
			advanceAmounts_new: processedAdvanceAmounts,
		});

		form.validateFields(['advanceAmounts_new', 'advanceAmount_new']);

		const currentChanges = form.getFieldValue('changes');

		if (currentChanges && currentChanges.length > 0) {
			const updatedChanges = [...currentChanges];

			updatedChanges[currentChanges.length - 1] = {
				...updatedChanges[currentChanges.length - 1],

				inputChangeAdvance: total > 0 ? total : 0,
				inputChangeAdvanceAmounts: processedAdvanceAmounts,
			};

			form.setFieldValue('changes', updatedChanges);
		}
	};

	useEffect(() => {
		const currentValues = form.getFieldValue('advanceAmountList_new');

		if (!currentValues || !currentValues.length) {
			form.setFieldValue('advanceAmountList_new', [{ from: 1, to: '', amount: '', totalAmount: '' }]);
		}

		calculateTotal();
		calculateRowTotals();
	}, []);

	return (
		<>
			<Typography
				variant="h4"
				sx={{ color: '#1a3b5d', padding: '0 0 12px 0', fontWeight: 600, fontSize: '18px', borderBottom: '1px solid #e0e6ed' }}
			>
				Basic Information
			</Typography>

			<Row gutter={[16, 0]} style={{ marginTop: '16px' }}>
				<Form.Item noStyle name="tabIndex" />
				<Form.Item noStyle name="endOfFinancialYear" />
				<Form.Item noStyle name={constantFormValues?.version?.key} />
				<Form.Item noStyle name={constantFormValues?.leaseTerm?.key} />
				<Form.Item noStyle name={constantFormValues?.lessorName?.key} />
				<Form.Item noStyle name={constantFormValues?.creationDate?.key} />
				<Form.Item noStyle name={constantFormValues?.paymentModality?.key} />
				<Form.Item noStyle name={constantFormValues?.lastModifiedDate?.key} />
				<Form.Item noStyle name={`${constantFormValues?.lessorName?.key}_new`} />
				<Form.Item noStyle name={constantFormValues?.paymentModalitylabel?.key} />

				<Col xs={24} md={6}>
					<InputLabel label={constantFormValues?.LeaseId?.label} head={true} />
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={constantFormValues?.LeaseId?.key}>
						<Input disabled placeholder="To be auto generated" style={{ height: '32px', borderRadius: '4px' }} />
					</Form.Item>
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={constantFormValues?.LeaseId?.key}>
						<Input disabled placeholder="To be auto generated" style={{ height: '32px', borderRadius: '4px' }} />
					</Form.Item>
				</Col>

				<Col xs={24} md={6}>
					<InputLabel label={constantFormValues?.leaseTitle?.label} head={true} />
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={constantFormValues?.leaseTitle?.key} rules={constantFormValues?.leaseTitle?.rules}>
						<Input disabled placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
					</Form.Item>
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={`${constantFormValues?.leaseTitle?.key}_new`} rules={constantFormValues?.leaseTitle?.rules}>
						<Input placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
					</Form.Item>
				</Col>

				<Col xs={24} md={6}>
					<InputLabel label={constantFormValues?.lessorID?.label} head={true} />
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={constantFormValues?.lessorID?.key} rules={constantFormValues?.lessorID?.rules}>
						<Select
							showSearch
							disabled={true}
							filterOption={true}
							optionFilterProp="children"
							placeholder="Select from the list"
							style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							onSelect={(_, selectItem) => form.setFieldValue(constantFormValues?.lessorName?.key, selectItem?.children)}
						>
							{vendorList?.map(({ label, value }) => (
								<Select.Option key={value} value={value}>
									{label}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={constantFormValues?.lessorID?.key} rules={constantFormValues?.lessorID?.rules}>
						<Select
							showSearch
							disabled={true}
							filterOption={true}
							optionFilterProp="children"
							placeholder="Select from the list"
							style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							onSelect={(_, selectItem) => form.setFieldValue(`${constantFormValues?.lessorName?.key}_new`, selectItem?.children)}
						>
							{vendorList?.map(({ label, value }) => (
								<Select.Option key={value} value={value}>
									{label}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				<Col xs={24} md={6}>
					<InputLabel label={constantFormValues?.leaseStartDate?.label} head={true} />
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={constantFormValues?.leaseStartDate?.key} rules={constantFormValues?.leaseStartDate?.rules}>
						<DatePicker
							disabled
							format="YYYY-MM-DD"
							onChange={handleLeaseDateChange}
							style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						/>
					</Form.Item>
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={constantFormValues?.leaseStartDate?.key} rules={constantFormValues?.leaseStartDate?.rules}>
						<DatePicker
							disabled
							format="YYYY-MM-DD"
							onChange={handleLeaseDateChange}
							style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						/>
					</Form.Item>
				</Col>

				<Col xs={24} md={6}>
					<InputLabel label={constantFormValues?.leaseEndDate?.label} head={true} />
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={constantFormValues?.leaseEndDate?.key} rules={constantFormValues?.leaseEndDate?.rules}>
						<DatePicker disabled value={LeaseEndDate} style={{ width: '100%', height: '32px', borderRadius: '4px' }} />
					</Form.Item>
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={`${constantFormValues?.leaseEndDate?.key}_new`} rules={constantFormValues?.leaseEndDate?.rules}>
						<DatePicker disabled value={LeaseEndDate} style={{ width: '100%', height: '32px', borderRadius: '4px' }} />
					</Form.Item>
				</Col>

				<Col xs={24} md={6}>
					<InputLabel label={constantFormValues?.leaseTerm?.label} head={true} />
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name="modifiedLeaseTerm" rules={constantFormValues?.leaseTerm?.rules} noStyle>
						<Input disabled type="number" placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
					</Form.Item>
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name="leaseTerm_new" rules={constantFormValues?.leaseTerm?.rules} noStyle>
						<Input type="number" disabled placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
					</Form.Item>
				</Col>

				<Col xs={24} md={6}>
					<InputLabel label={constantFormValues?.leaseType?.label} head={true} />
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={constantFormValues?.leaseType?.key} rules={constantFormValues?.leaseType?.rules}>
						<Select
							disabled
							showSearch
							filterOption={true}
							optionFilterProp="children"
							placeholder="Select from the list"
							style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							onSelect={(value) => {
								if (value === 'Operating Lease') {
									form.setFieldValue('grossRentList', [{ from: 1, to: '', amount: '', remarks: '' }]);
									form.setFieldValue('advanceAmountList', [
										{
											from: 1,
											to: '',
											amount: '',
											totalAmount: '',
										},
									]);
								}
							}}
						>
							{constantFormValues?.leaseType?.options?.map(({ key, value, label }) => (
								<Select.Option key={key} value={value}>
									{label}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Col xs={24} md={9}>
					<Form.Item name={`${constantFormValues?.leaseType?.key}`} rules={constantFormValues?.leaseType?.rules}>
						<Select
							disabled
							showSearch
							filterOption={true}
							optionFilterProp="children"
							placeholder="Select from the list"
							style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							onSelect={(value) => {
								if (value === 'Operating Lease') {
									form.setFieldValue('grossRentList', [{ from: 1, to: '', amount: '', remarks: '' }]);
									form.setFieldValue('advanceAmountList', [
										{
											from: 1,
											to: '',
											amount: '',
											totalAmount: '',
										},
									]);
								}
							}}
						>
							{constantFormValues?.leaseType?.options?.map(({ key, value, label }) => (
								<Select.Option key={key} value={value}>
									{label}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				<Col xs={24}>
					<Form.Item
						shouldUpdate={(previousValue, currentValue) =>
							previousValue?.[constantFormValues?.leaseType?.key] !== currentValue?.[constantFormValues?.leaseType?.key]
						}
						noStyle
					>
						{({ getFieldValue }) => {
							if (getFieldValue(constantFormValues?.leaseType?.key) === 'Finance Lease') {
								return (
									<Row gutter={[16, 0]}>
										<Col xs={24} md={6}>
											<InputLabel label={constantFormValues?.initialDiscountRate?.label} head={true} />
										</Col>
										<Col xs={24} md={9}>
											<Form.Item
												name={constantFormValues?.initialDiscountRate?.key}
												rules={constantFormValues?.initialDiscountRate?.rules}
												getValueFromEvent={(e) => {
													const value = e.target.value;
													const currentChanges = form.getFieldValue('changes');

													form.setFieldValue(['changes', currentChanges.length - 1, 'inputChangeDiscountRate'], value);
												}}
											>
												<Input disabled placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
											</Form.Item>
										</Col>
										<Col xs={24} md={9}>
											<Form.Item
												rules={constantFormValues?.initialDiscountRate?.rules}
												name={`${constantFormValues?.initialDiscountRate?.key}_new`}
											>
												<Input
													placeholder="Write here"
													style={{ height: '32px', borderRadius: '4px' }}
													onChange={(e) => {
														const value = e.target.value;
														const currentChanges = form.getFieldValue('changes');

														form.setFieldValue(`${constantFormValues?.initialDiscountRate?.key}_new`, value);

														form.setFieldValue(['changes', currentChanges.length - 1, 'inputChangeDiscountRate'], value);
													}}
												/>
											</Form.Item>
										</Col>
									</Row>
								);
							} else {
								return <Form.Item name={constantFormValues?.initialDiscountRate?.key} noStyle />;
							}
						}}
					</Form.Item>
				</Col>
			</Row>

			<Row gutter={[16, 0]}>
				<Col xs={24} md={12}>
					<Typography
						variant="h4"
						sx={{
							color: '#1a3b5d',
							padding: '0 0 12px 0',
							fontWeight: 600,
							fontSize: '18px',
							borderBottom: '1px solid #e0e6ed',
							marginBottom: '16px',
						}}
					>
						Lease Payment Schedule
					</Typography>

					<Form.Item name="changes" noStyle />

					<Form.Item name="identityId" noStyle />
					<Form.Item name="grossRentListSet" noStyle />
					<Form.Item name="effectiveDateHistory" noStyle />
					<Form.Item name="modificationSequence" noStyle />

					<Form.List name={'grossRentList'}>
						{(fields) => (
							<>
								<TableContainer
									className="gross-rent-table"
									sx={{
										'& table, & th, & td': {
											border: '1px solid #e0e0e0',
											borderCollapse: 'collapse',
										},
										'& th, & td': {
											p: '5px',
										},
										'& td .ant-form-item': {
											marginBottom: '0px',
										},

										'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
										'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
										'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

										'& table': { width: '100%' },
									}}
								>
									<Table aria-label="Gross Rent table">
										<TableHead>
											<TableRow>
												<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
													From Month
												</TableCell>
												<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
													To Month
												</TableCell>
												<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
													Amount
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{fields.length > 0 ? (
												fields.map((field, index) => (
													<TableRow key={field.key}>
														<TableCell>
															<Form.Item name={[field.name, 'from']}>
																<Input
																	disabled={true}
																	style={{
																		width: '100%',
																		padding: '5px 11px',
																		textAlign: 'center',
																		backgroundColor: '#f5f5f5',
																	}}
																/>
															</Form.Item>
														</TableCell>

														<TableCell>
															<Form.Item name={[field.name, 'to']}>
																<Input
																	disabled
																	type="number"
																	placeholder="Enter To value"
																	style={{
																		width: '100%',
																		padding: '5px 11px',

																		textAlign: 'center',
																	}}
																/>
															</Form.Item>
														</TableCell>

														<TableCell>
															<Form.Item
																name={[field.name, 'amount']}
																rules={[{ required: true, message: 'Please enter an amount' }]}
															>
																<NumericFormat
																	size="small"
																	disabled={true}
																	decimalScale={2}
																	placeholder="0.00"
																	fixedDecimalScale
																	thousandSeparator=","
																	isAllowed={withValueCap}
																	customInput={Input}
																	style={{
																		height: '32px',
																		padding: '5px 11px',
																		fontSize: '13px',
																		textAlign: 'right',
																		borderRadius: '4px',
																	}}
																/>
															</Form.Item>
														</TableCell>
													</TableRow>
												))
											) : (
												<TableRow>
													<TableCell colSpan={5} style={{ textAlign: 'center' }}>
														No data. Click plus icon in action column to add new entries.
													</TableCell>
												</TableRow>
											)}
										</TableBody>
									</Table>
								</TableContainer>

								<Form.Item name="grossRents" noStyle />
							</>
						)}
					</Form.List>

					<Row gutter={[16, 0]} style={{ marginTop: '16px' }}>
						<Col xs={24} md={12}>
							<Form.Item name={constantFormValues?.paymentFrequency?.key} label={constantFormValues?.paymentFrequency?.label}>
								<Select
									disabled
									showSearch
									filterOption={true}
									optionFilterProp="children"
									placeholder="Select from the list"
									style={{ width: '100%', height: '32px', borderRadius: '4px' }}
								>
									{constantFormValues?.paymentFrequency?.options?.map(({ key, value, label }) => (
										<Select.Option key={key} value={value}>
											{label}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={24} md={12}>
							<Form.Item name={constantFormValues?.paymentModality?.key} label={constantFormValues?.paymentModality?.label}>
								<Select
									disabled
									showSearch
									filterOption={true}
									optionFilterProp="children"
									placeholder="Select from the list"
									style={{ width: '100%', height: '32px', borderRadius: '4px' }}
								>
									{constantFormValues?.paymentModality?.options?.map(({ key, value, label }) => (
										<Select.Option key={key} value={value}>
											{label}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>
					</Row>
				</Col>

				<Col xs={24} md={12}>
					<Typography
						variant="h4"
						sx={{
							color: '#1a3b5d',
							padding: '0 0 12px 0',
							fontWeight: 600,
							fontSize: '18px',
							borderBottom: '1px solid #e0e6ed',
							marginBottom: '16px',
						}}
					>
						Lease Payment Schedule
					</Typography>

					<Form.Item name="identityId" noStyle />
					<Form.Item name="grossRentListSet" noStyle />
					<Form.Item name="effectiveDateHistory" noStyle />
					<Form.Item name="modificationSequence" noStyle />

					<Form.List name={'grossRentList_new'}>
						{(fields) => (
							<>
								<TableContainer
									className="gross-rent-table"
									sx={{
										'& table, & th, & td': {
											border: '1px solid #e0e0e0',
											borderCollapse: 'collapse',
										},
										'& th, & td': {
											p: '5px',
										},
										'& td .ant-form-item': {
											marginBottom: '0px',
										},

										'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
										'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
										'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

										'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '10%' },

										'& table': { width: '100%' },
									}}
								>
									<Table aria-label="Gross Rent table">
										<TableHead>
											<TableRow>
												<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
													From Month
												</TableCell>
												<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
													To Month
												</TableCell>
												<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
													Amount
												</TableCell>
												<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
													Action
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{fields.length > 0 ? (
												fields.map((field, index) => (
													<TableRow key={field.key}>
														<TableCell>
															<Form.Item name={[field.name, 'from']}>
																<Input
																	disabled={true}
																	style={{
																		width: '100%',
																		padding: '5px 11px',
																		textAlign: 'center',
																		backgroundColor: '#f5f5f5',
																	}}
																/>
															</Form.Item>
														</TableCell>

														<TableCell>
															<Form.Item
																name={[field.name, 'to']}
																rules={[
																	{ required: true, message: "Please enter a 'To' value" },
																	({ getFieldValue }) => ({
																		validator(_, value) {
																			const leaseType = getFieldValue('leaseType');
																			const fromValue = getFieldValue(['grossRentList', field.name, 'from']);
																			if (!value || !fromValue) return Promise.resolve();
																			if (parseInt(value) < parseInt(fromValue)) {
																				return Promise.reject(new Error("'To' must be greater than 'From'"));
																			}
																			if (leaseType === 'Operating Lease' && parseInt(value) > 12) {
																				return Promise.reject(new Error('Maximum month is 12'));
																			}
																			return Promise.resolve();
																		},
																	}),
																]}
															>
																<Input
																	type="number"
																	placeholder="Enter To value"
																	onBlur={() => validateToValueOnBlur(index)}
																	onChange={() => handleToChange(`${'grossRentList'}.${field.name}.to`)}
																	style={{
																		width: '100%',
																		padding: '5px 11px',

																		textAlign: 'center',
																	}}
																/>
															</Form.Item>
														</TableCell>

														<TableCell>
															<Form.Item
																name={[field.name, 'amount']}
																rules={[{ required: true, message: 'Please enter an amount' }]}
															>
																<NumericFormat
																	size="small"
																	decimalScale={2}
																	placeholder="0.00"
																	fixedDecimalScale
																	thousandSeparator=","
																	isAllowed={withValueCap}
																	customInput={Input}
																	disabled={screen === 'VIEW'}
																	onBlur={() => setTimeout(handleApply, 10)}
																	style={{
																		height: '32px',
																		padding: '5px 11px',
																		fontSize: '13px',
																		textAlign: 'right',
																		borderRadius: '4px',
																	}}
																	onValueChange={(values) => {
																		handleAmountChange(`${'grossRentList_new'}.${field.name}.amount`);
																		const currentValues = [...form.getFieldValue('grossRentList_new')];

																		if (currentValues[index]) {
																			currentValues[index].amount = values.value || '';

																			form.setFieldValue('grossRentList_new', currentValues);
																		}
																	}}
																/>
															</Form.Item>
														</TableCell>

														<TableCell align="center">
															<Stack sx={{ flexDirection: 'row', justifyContent: 'center' }}>
																{fields.length === 1 && index === 0 && (
																	<Tooltip title="Add Row">
																		<AddIconButton onClick={() => handleAddRow(index)} />
																	</Tooltip>
																)}

																{fields.length > 1 && index > 0 && index < fields.length - 1 && (
																	<Tooltip title="Delete Row">
																		<DeleteIconButton
																			onClick={() => {
																				const currentValues = [...form.getFieldValue('grossRentList_new')];

																				currentValues.splice(index, 1);

																				for (let i = index; i < currentValues.length; i++) {
																					if (i > 0) {
																						const prevTo = parseInt(currentValues[i - 1].to);
																						if (!isNaN(prevTo)) {
																							currentValues[i].from = prevTo + 1;
																						}
																					}
																				}

																				form.setFieldValue('grossRentList_new', currentValues);

																				setTimeout(handleApply, 10);
																			}}
																		/>
																	</Tooltip>
																)}

																{fields.length > 1 && index === fields.length - 1 && (
																	<>
																		<Tooltip title="Add Row">
																			<AddIconButton onClick={() => handleAddRow(index)} />
																		</Tooltip>

																		<Tooltip title="Delete Row">
																			<DeleteIconButton
																				onClick={() => {
																					const currentValues = [
																						...form.getFieldValue('grossRentList_new'),
																					];

																					currentValues.splice(index, 1);

																					for (let i = index; i < currentValues.length; i++) {
																						if (i > 0) {
																							const prevTo = parseInt(currentValues[i - 1].to);
																							if (!isNaN(prevTo)) {
																								currentValues[i].from = prevTo + 1;
																							}
																						}
																					}

																					form.setFieldValue('grossRentList_new', currentValues);

																					setTimeout(handleApply, 10);
																				}}
																			/>
																		</Tooltip>
																	</>
																)}

																{fields.length > 1 && index === 0 && <span></span>}
															</Stack>
														</TableCell>
													</TableRow>
												))
											) : (
												<TableRow>
													<TableCell colSpan={5} style={{ textAlign: 'center' }}>
														No data. Click plus icon in action column to add new entries.
													</TableCell>
												</TableRow>
											)}
										</TableBody>
									</Table>
								</TableContainer>

								<Form.Item name="grossRents_new" noStyle />
							</>
						)}
					</Form.List>

					<Row gutter={[16, 0]} style={{ marginTop: '16px' }}>
						<Col xs={24} md={12}>
							<Form.Item
								getValueFromEvent={handlePaymentFrequencyChange}
								rules={constantFormValues?.paymentFrequency?.rules}
								label={constantFormValues?.paymentFrequency?.label}
								name={`${constantFormValues?.paymentFrequency?.key}_new`}
							>
								<Select
									showSearch
									filterOption={true}
									optionFilterProp="children"
									placeholder="Select from the list"
									onBlur={handlePaymentFrequencyBlur}
									style={{ width: '100%', height: '32px', borderRadius: '4px' }}
								>
									{constantFormValues?.paymentFrequency?.options?.map(({ key, value, label }) => (
										<Select.Option key={key} value={value}>
											{label}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={24} md={12}>
							<Form.Item
								getValueFromEvent={handlePaymentModalityChange}
								rules={constantFormValues?.paymentModality?.rules}
								label={constantFormValues?.paymentModality?.label}
								name={`${constantFormValues?.paymentModality?.key}_new`}
							>
								<Select
									showSearch
									filterOption={true}
									optionFilterProp="children"
									onBlur={handlePaymentModalityBlur}
									placeholder="Select from the list"
									style={{ width: '100%', height: '32px', borderRadius: '4px' }}
								>
									{constantFormValues?.paymentModality?.options?.map(({ key, value, label }) => (
										<Select.Option key={key} value={value}>
											{label}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>
					</Row>
				</Col>

				<Col xs={24} md={12}>
					<Typography
						variant="h4"
						sx={{
							color: '#1a3b5d',
							padding: '0 0 12px 0',
							fontWeight: 600,
							fontSize: '18px',
							borderBottom: '1px solid #e0e6ed',
							marginBottom: '16px',
						}}
					>
						Advance Payment & Adjustment
					</Typography>

					<Form.Item name="advanceAmountListSet" noStyle />

					<Form.List name={'advanceAmountList'}>
						{(fields) => {
							return (
								<>
									<TableContainer
										className="gross-rent-table"
										sx={{
											'& table, & th, & td': {
												border: '1px solid #e0e0e0',
												borderCollapse: 'collapse',
											},
											'& th, & td': {
												p: '5px',
											},
											'& td .ant-form-item': {
												marginBottom: '0px',
											},

											'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
											'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
											'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

											'& table': { width: '100%' },
										}}
									>
										<Table aria-label="Gross Rent table">
											<TableHead>
												<TableRow>
													<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
														From Month
													</TableCell>
													<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
														To Month
													</TableCell>
													<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
														Monthly Adjustment
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{fields.length > 0 ? (
													fields.map((field, index) => (
														<TableRow key={field.key}>
															<TableCell>
																<Form.Item name={[field.name, 'from']}>
																	<Input
																		disabled={true}
																		style={{
																			padding: '5px 11px',
																			width: '100%',
																			backgroundColor: '#f5f5f5',
																			textAlign: 'center',
																		}}
																	/>
																</Form.Item>
															</TableCell>

															<TableCell>
																<Form.Item name={[field.name, 'to']}>
																	<Input
																		disabled
																		type="number"
																		placeholder="Enter To value"
																		style={{
																			padding: '5px 11px',
																			width: '100%',

																			textAlign: 'center',
																		}}
																	/>
																</Form.Item>
															</TableCell>
															<TableCell>
																<Form.Item name={[field.name, 'amount']}>
																	<NumericFormat
																		disabled
																		size="small"
																		decimalScale={2}
																		placeholder="0.00"
																		fixedDecimalScale
																		thousandSeparator=","
																		isAllowed={withValueCap}
																		style={{
																			padding: '5px 11px',
																			textAlign: 'right',
																			height: '32px',
																			borderRadius: '4px',
																			fontSize: '13px',
																		}}
																		customInput={Input}
																	/>
																</Form.Item>
															</TableCell>
														</TableRow>
													))
												) : (
													<TableRow>
														<TableCell colSpan={5} style={{ textAlign: 'center' }}>
															No data. Click the plus icon to add new entries.
														</TableCell>
													</TableRow>
												)}
											</TableBody>
											<TableFooter>
												<TableRow sx={{ height: 24 }}>
													<TableCell
														colSpan={2}
														align="right"
														sx={{ fontWeight: 'bold', fontSize: '13px', backgroundColor: '#f6f5f5', pr: '14px' }}
													>
														Advance Payment
													</TableCell>

													<TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
														<NumericFormat
															value={totalAmount || 0}
															displayType="input"
															decimalScale={2}
															fixedDecimalScale
															thousandSeparator=","
															size="small"
															style={{
																padding: '5px 11px',
																textAlign: 'right',
																height: '32px',
																borderRadius: '4px',
																fontSize: '13px',
																fontWeight: 'bold',
																backgroundColor: undefined,
																borderColor: undefined,
															}}
															customInput={Input}
															disabled={true}
															readOnly={true}
														/>
													</TableCell>
												</TableRow>
											</TableFooter>
										</Table>
									</TableContainer>

									<Form.Item name="advanceAmounts" noStyle />
								</>
							);
						}}
					</Form.List>
				</Col>

				<Col xs={24} md={12}>
					<Typography
						variant="h4"
						sx={{
							color: '#1a3b5d',
							padding: '0 0 12px 0',
							fontWeight: 600,
							fontSize: '18px',
							borderBottom: '1px solid #e0e6ed',
							marginBottom: '16px',
						}}
					>
						Advance Payment & Adjustment
					</Typography>

					<Form.Item name="advanceAmountListSet" noStyle />

					<Form.List name={'advanceAmountList_new'}>
						{(fields) => {
							return (
								<>
									<TableContainer
										className="gross-rent-table"
										sx={{
											'& table, & th, & td': {
												border: '1px solid #e0e0e0',
												borderCollapse: 'collapse',
											},
											'& th, & td': {
												p: '5px',
											},
											'& td .ant-form-item': {
												marginBottom: '0px',
											},

											'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '30%' },
											'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '30%' },
											'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '30%' },

											'& table': { width: '100%' },
										}}
									>
										<Table aria-label="Gross Rent table">
											<TableHead>
												<TableRow>
													<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
														From Month
													</TableCell>
													<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
														To Month
													</TableCell>
													<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
														Monthly Adjustment
													</TableCell>
													{screen !== 'VIEW' && screen !== 'EDIT' && (
														<TableCell sx={{ fontSize: '13px', backgroundColor: '#f6f5f5', textAlign: 'center' }}>
															Action
														</TableCell>
													)}
												</TableRow>
											</TableHead>

											<TableBody>
												{fields.length > 0 ? (
													fields.map((field, index) => (
														<TableRow key={field.key}>
															<TableCell>
																<Form.Item name={[field.name, 'from']}>
																	<Input
																		disabled={true}
																		style={{
																			padding: '5px 11px',
																			width: '100%',
																			backgroundColor: '#f5f5f5',
																			textAlign: 'center',
																		}}
																	/>
																</Form.Item>
															</TableCell>

															<TableCell>
																<Form.Item
																	name={[field.name, 'to']}
																	rules={[
																		{ required: false, message: "Please enter a 'To' value" },
																		({ getFieldValue }) => ({
																			validator(_, value) {
																				const leaseType = getFieldValue('leaseType');
																				const fromValue = getFieldValue([
																					'advanceAmountList_new',
																					field.name,
																					'from',
																				]);
																				if (!value || !fromValue) return Promise.resolve();
																				if (parseInt(value) < parseInt(fromValue)) {
																					return Promise.reject(
																						new Error("'To' must be greater than 'From'")
																					);
																				}
																				if (leaseType === 'Operating Lease' && parseInt(value) > 12) {
																					return Promise.reject(new Error('Maximum month is 12'));
																				}
																				return Promise.resolve();
																			},
																		}),
																	]}
																>
																	<Input
																		type="number"
																		disabled={screen === 'VIEW' || screen === 'EDIT'}
																		placeholder="Enter To value"
																		style={{
																			padding: '5px 11px',
																			width: '100%',

																			textAlign: 'center',
																		}}
																		onChange={() =>
																			handleToChangeAdvanceAmount(`${'advanceAmountList_new'}.${field.name}.to`)
																		}
																		onBlur={() => validateToValueOnBlurAdvanceAmount(index)}
																	/>
																</Form.Item>
															</TableCell>
															<TableCell>
																<Form.Item
																	name={[field.name, 'amount']}
																	rules={[{ required: false, message: 'Please enter an amount' }]}
																>
																	<NumericFormat
																		size="small"
																		decimalScale={2}
																		placeholder="0.00"
																		fixedDecimalScale
																		thousandSeparator=","
																		isAllowed={withValueCap}
																		style={{
																			padding: '5px 11px',
																			textAlign: 'right',
																			height: '32px',
																			borderRadius: '4px',
																			fontSize: '13px',
																		}}
																		customInput={Input}
																		disabled={screen === 'VIEW' || screen === 'EDIT'}
																		onValueChange={(values) => {
																			handleAmountChangeAdvanceAmount(
																				`${'advanceAmountList_new'}.${field.name}.amount`
																			);
																			const currentValues = [...form.getFieldValue('advanceAmountList_new')];

																			if (currentValues[index]) {
																				currentValues[index].amount = values.value || '';

																				form.setFieldValue('advanceAmountList_new', currentValues);

																				const fromValue = parseInt(currentValues[index].from);
																				const toValue = parseInt(currentValues[index].to);

																				if (!values.value) {
																					const newRowTotals = [...rowTotals];
																					newRowTotals[index] = 0;
																					setRowTotals(newRowTotals);

																					const newTotal = newRowTotals.reduce(
																						(total, rowTotal) => total + (rowTotal || 0),
																						0
																					);
																					setTotalAmountNew(newTotal);
																					return;
																				}

																				const amount = parseFloat(values.value);

																				if (
																					!isNaN(fromValue) &&
																					!isNaN(toValue) &&
																					!isNaN(amount) &&
																					toValue >= fromValue
																				) {
																					const newRowTotals = [...rowTotals];
																					newRowTotals[index] = (toValue - fromValue + 1) * amount;
																					setRowTotals(newRowTotals);

																					const newTotal = newRowTotals.reduce(
																						(total, rowTotal) => total + (rowTotal || 0),
																						0
																					);
																					setTotalAmountNew(newTotal);
																				}
																			}
																		}}
																		onBlur={() => {
																			setTimeout(() => {
																				calculateRowTotals();
																				calculateTotal();
																				handleApplyAdvanceAmount();
																			}, 10);
																		}}
																	/>
																</Form.Item>
															</TableCell>

															<TableCell align="center">
																<Stack sx={{ flexDirection: 'row', justifyContent: 'center' }}>
																	{fields.length === 1 && index === 0 && (
																		<Tooltip title="Add Row">
																			<AddIconButton onClick={() => handleAddRowAdvanceAmount(index)} />
																		</Tooltip>
																	)}

																	{fields.length > 1 && index > 0 && index < fields.length - 1 && (
																		<Tooltip title="Delete Row">
																			<DeleteIconButton
																				onClick={() => {
																					const currentValues = [
																						...form.getFieldValue('advanceAmountList_new'),
																					];

																					const newRowTotals = [...rowTotals];
																					newRowTotals.splice(index, 1);
																					setRowTotals(newRowTotals);

																					currentValues.splice(index, 1);

																					for (let i = index; i < currentValues.length; i++) {
																						if (i > 0) {
																							const prevTo = parseInt(currentValues[i - 1].to);
																							if (!isNaN(prevTo)) {
																								currentValues[i].from = prevTo + 1;
																							}
																						}
																					}

																					form.setFieldValue('advanceAmountList_new', currentValues);

																					const newTotal = newRowTotals.reduce(
																						(total, rowTotal) => total + (rowTotal || 0),
																						0
																					);
																					setTotalAmountNew(newTotal);
																					handleApplyAdvanceAmount();
																				}}
																			/>
																		</Tooltip>
																	)}

																	{fields.length > 1 && index === fields.length - 1 && (
																		<>
																			<Tooltip title="Add Row">
																				<AddIconButton onClick={() => handleAddRowAdvanceAmount(index)} />
																			</Tooltip>

																			<Tooltip title="Delete Row">
																				<DeleteIconButton
																					onClick={() => {
																						const currentValues = [
																							...form.getFieldValue('advanceAmountList_new'),
																						];

																						const newRowTotals = [...rowTotals];
																						newRowTotals.splice(index, 1);
																						setRowTotals(newRowTotals);

																						currentValues.splice(index, 1);

																						for (let i = index; i < currentValues.length; i++) {
																							if (i > 0) {
																								const prevTo = parseInt(currentValues[i - 1].to);
																								if (!isNaN(prevTo)) {
																									currentValues[i].from = prevTo + 1;
																								}
																							}
																						}

																						form.setFieldValue('advanceAmountList_new', currentValues);

																						const newTotal = newRowTotals.reduce(
																							(total, rowTotal) => total + (rowTotal || 0),
																							0
																						);
																						setTotalAmountNew(newTotal);
																						handleApplyAdvanceAmount();
																					}}
																				/>
																			</Tooltip>
																		</>
																	)}

																	{fields.length > 1 && index === 0 && <span></span>}
																</Stack>
															</TableCell>
														</TableRow>
													))
												) : (
													<TableRow>
														<TableCell colSpan={5} style={{ textAlign: 'center' }}>
															No data. Click the plus icon to add new entries.
														</TableCell>
													</TableRow>
												)}
											</TableBody>
											<TableFooter>
												<TableRow sx={{ height: 24 }}>
													<TableCell
														colSpan={2}
														align="right"
														sx={{ fontWeight: 'bold', fontSize: '13px', backgroundColor: '#f6f5f5', pr: '14px' }}
													>
														Advance Payment
													</TableCell>

													<TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
														<NumericFormat
															value={totalAmountNew || 0}
															displayType="input"
															decimalScale={2}
															fixedDecimalScale
															thousandSeparator=","
															size="small"
															style={{
																padding: '5px 11px',
																textAlign: 'right',
																height: '32px',
																borderRadius: '4px',
																fontSize: '13px',
																fontWeight: 'bold',
																backgroundColor: undefined,
																borderColor: undefined,
															}}
															customInput={Input}
															disabled={true}
															readOnly={true}
														/>
													</TableCell>

													<TableCell colSpan={1}></TableCell>
												</TableRow>
											</TableFooter>
										</Table>
									</TableContainer>

									<Form.Item name="advanceAmounts_new" noStyle />
								</>
							);
						}}
					</Form.List>
				</Col>

				<Col xs={24}>
					<Typography
						variant="h4"
						sx={{
							fontWeight: 600,
							fontSize: '18px',
							marginTop: '16px',
							color: '#1a3b5d',
							marginBottom: '16px',
							padding: '0 0 12px 0',
							borderBottom: '1px solid #e0e6ed',
						}}
					>
						Other Payments & Incentive
					</Typography>

					<Row gutter={[16, 0]}>
						<Col xs={24} md={6}>
							<InputLabel label={constantFormValues?.upfrontLeasePayment?.label} head={true} />
						</Col>
						<Col xs={24} md={9}>
							<Form.Item name={constantFormValues?.upfrontLeasePayment?.key} rules={constantFormValues?.upfrontLeasePayment?.rules}>
								<NumericFormat
									disabled
									size="large"
									decimalScale={2}
									placeholder="0.00"
									fixedDecimalScale
									customInput={Input}
									thousandSeparator=","
									isAllowed={withValueCap}
									style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} md={9}>
							<Form.Item
								name={`${constantFormValues?.upfrontLeasePayment?.key}_new`}
								rules={constantFormValues?.upfrontLeasePayment?.rules}
							>
								<NumericFormat
									size="large"
									decimalScale={2}
									placeholder="0.00"
									fixedDecimalScale
									customInput={Input}
									thousandSeparator=","
									isAllowed={withValueCap}
									style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} md={6}>
							<InputLabel label={constantFormValues?.initialDirectCost?.label} head={true} />
						</Col>
						<Col xs={24} md={9}>
							<Form.Item name={constantFormValues?.initialDirectCost?.key} rules={constantFormValues?.initialDirectCost?.rules}>
								<NumericFormat
									disabled
									size="large"
									decimalScale={2}
									placeholder="0.00"
									fixedDecimalScale
									customInput={Input}
									thousandSeparator=","
									isAllowed={withValueCap}
									style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} md={9}>
							<Form.Item
								rules={constantFormValues?.initialDirectCost?.rules}
								name={`${constantFormValues?.initialDirectCost?.key}_new`}
							>
								<NumericFormat
									size="large"
									decimalScale={2}
									placeholder="0.00"
									fixedDecimalScale
									customInput={Input}
									thousandSeparator=","
									isAllowed={withValueCap}
									style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} md={6}>
							<InputLabel label={constantFormValues?.securityDeposit?.label} head={true} />
						</Col>
						<Col xs={24} md={9}>
							<Form.Item name={constantFormValues?.securityDeposit?.key} rules={constantFormValues?.securityDeposit?.rules}>
								<NumericFormat
									disabled
									size="large"
									decimalScale={2}
									placeholder="0.00"
									fixedDecimalScale
									customInput={Input}
									thousandSeparator=","
									isAllowed={withValueCap}
									style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} md={9}>
							<Form.Item rules={constantFormValues?.securityDeposit?.rules} name={`${constantFormValues?.securityDeposit?.key}_new`}>
								<NumericFormat
									size="large"
									decimalScale={2}
									placeholder="0.00"
									fixedDecimalScale
									customInput={Input}
									thousandSeparator=","
									isAllowed={withValueCap}
									style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} md={6}>
							<InputLabel label={constantFormValues?.cashIncentiveAmount?.label} head={true} />
						</Col>
						<Col xs={24} md={9}>
							<Form.Item name={constantFormValues?.cashIncentiveAmount?.key} rules={constantFormValues?.securityDeposit?.rules}>
								<NumericFormat
									disabled
									size="large"
									decimalScale={2}
									fixedDecimalScale
									placeholder="0.00"
									customInput={Input}
									thousandSeparator=","
									isAllowed={withValueCap}
									style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} md={9}>
							<Form.Item
								rules={constantFormValues?.securityDeposit?.rules}
								name={`${constantFormValues?.cashIncentiveAmount?.key}_new`}
							>
								<NumericFormat
									size="large"
									decimalScale={2}
									fixedDecimalScale
									placeholder="0.00"
									customInput={Input}
									thousandSeparator=","
									isAllowed={withValueCap}
									style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
								/>
							</Form.Item>
						</Col>
					</Row>
				</Col>

				<Form.Item name="grossRents" noStyle />
				<Form.Item name="grossRents_new" noStyle />
				<Form.Item name="advanceAmounts" noStyle />
				<Form.Item name="advanceAmounts_new" noStyle />
				<Form.Item name={constantFormValues?.advanceAmount?.key} noStyle />
				<Form.Item name={`${constantFormValues?.advanceAmount?.key}_new`} noStyle />
				<Form.Item noStyle name={constantFormValues?.inputChangeMonth?.key} />
			</Row>

			<Box
				sx={{
					gap: '4px',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
				}}
			>
				<Spin spinning={isLeaseControlDataLoading || isUpdateLoading}>
					<Box
						sx={{
							gap: '4px',
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
						}}
					>
						{screen !== 'VIEW' ? (
							<Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
								<Button
									type="primary"
									onClick={handleSubmitAction}
									style={{
										borderRadius: '4px',
										backgroundColor: theme.palette.lynTheme.main,
									}}
								>
									{screen === 'CREATE' ? 'Submit' : 'Update'}
								</Button>
							</Box>
						) : (
							<Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
								{viewData && (
									<>
										{!isDraft ? (
											<Button
												style={{
													margin: '1px',
													display: 'flex',
													fontSize: '13px',
													marginLeft: '6px',
													fontWeight: '500',
													borderRadius: '4px',
													alignItems: 'center',
												}}
												icon={<img src={editIcon} width={16} height={16} alt="edit" />}
												onClick={(e) => {
													e.stopPropagation();
													if (navigate && state) {
														navigate('/static/lease-record-management-v9/edit', {
															state: state,
														});
													}
												}}
											>
												Modify
											</Button>
										) : (
											<Button
												type="primary"
												onClick={handleSubmitClick}
												style={{
													borderRadius: '4px',
													backgroundColor: theme.palette.lynTheme.main,
												}}
											>
												Submit
											</Button>
										)}

										<Button
											style={{
												display: 'flex',
												marginLeft: '6px',
												borderRadius: '4px',
												alignItems: 'center',
											}}
											icon={<img src={editIcon} width={16} height={16} alt="edit" />}
											onClick={(e) => {
												e.stopPropagation();
												if (navigate && state) {
													navigate('/static/lease-record-management-v9/revise', {
														state: state,
													});
												}
											}}
										>
											Edit
										</Button>

										{areAllRecordsRecorded &&
											isLeaseLifeCycleOver() &&
											(viewData?.activationStatus !== 'Closed' ? (
												<Button
													style={{
														display: 'flex',
														fontSize: '13px',
														marginLeft: '6px',
														fontWeight: '500',
														borderRadius: '4px',
														alignItems: 'center',
													}}
													icon={<AssignmentTurnedInOutlinedIcon />}
													onClick={(e) => {
														e.stopPropagation();
														handleSingleLeaseDeactivate('Closed');
													}}
												>
													Close
												</Button>
											) : (
												<Button
													style={{
														margin: '1px',
														display: 'flex',
														fontSize: '13px',
														fontWeight: '500',
														marginLeft: '6px',
														borderRadius: '4px',
														alignItems: 'center',
													}}
													icon={<RestorePageOutlinedIcon />}
													onClick={(e) => {
														e.stopPropagation();
														handleSingleLeaseDeactivate('Reopened');
													}}
												>
													Reopen
												</Button>
											))}
									</>
								)}
							</Box>
						)}
					</Box>
				</Spin>

				{showClosedModal && (
					<ComptrollerConfirmModal
						modalData={modalData}
						showModal={showClosedModal}
						setShowModal={setShowClosedModal}
						handleSubmit={modalSubmitHandler}
					/>
				)}

				{formState?.showFormSubmitModal && (
					<ComptrollerConfirmModal
						modalData={formState?.modalData}
						handleSubmit={handleModalSubmit}
						setShowModal={setShowFormSubmitModal}
						showModal={formState?.showFormSubmitModal}
					/>
				)}
			</Box>
		</>
	);
};

export default LeaseRecordManagementV9EditBasicInfo;
